<template>
	<div id="listform" class="col-block">
		<div class="block-header has-border" v-if="formTitle">
			<h3>
				<strong>{{ formTitle }}</strong>
			</h3>
			<!-- <el-button class="ml-5"
            v-if="recordToEdit.statusKey===0">取消申請</el-button>-->
			<!--  如果要使用title旁的另外的輔助title 使用 subtitle -->
			<h3 v-if="subTitle" class="subTitle ml-2" style="color: red">
				{{ subTitle }}
			</h3>
			<!--  如果要使用title旁的按鈕新增可使用subBtn -->
			<span class="btn-control ml-3" v-if="subBtn">
				<el-button
					v-for="(btn, idx) in subBtn"
					:key="idx"
					:type="btn.type"
					v-if="btn.clickFunction"
					@click="btn.clickFunction"
					:plain="btn.plain"
					>{{ btn.label }}</el-button
				>
			</span>
			<span v-if="subTime" class="subtime">{{ subTime }}</span>
		</div>
		<div class="block-content">
			<slot></slot>
			<el-form
				:label-position="labelPosition"
				label-width="100px"
				:model="recordToEdit"
				:rules="rules"
				ref="recordToEdit"
			>
				<el-form-item
					v-if="item.vif !== false"
					v-show="item.vshow !== false"
					v-for="(item, index) in formType"
					:label="
						item.subTitle ? item.label + item.subTitle : item.label
					"
					:prop="
						typeof item.key == 'string'
							? item.key
							: item.key
							? item.key[0]
							: undefined
					"
					:key="index"
					:class="{
						inlineb: item.width,
						mr10: item.width,
						'is-required': item.require,
					}"
					:style="{ width: item.width }"
				>
					<!-- text 根據 options 顯示值 -->
					<span
						v-if="item.type == 'text' && item.options.length > 0"
						>{{ item.options[recordToEdit[item.key]] }}</span
					>
					<!-- text 單純顯示值-->
					<span v-else-if="item.type == 'text'">{{
						recordToEdit[item.key]
					}}</span>
					<!-- input prepend 前置元素 append 後置元素 -->
					<el-input
						v-model="recordToEdit[item.key]"
						:placeholder="
							item.disabled
								? ''
								: item.palceholderTitleChange
								? item.palceholderTitleChange
								: item.placeholder
								? item.placeholder
								: item.label
								? `請輸入${item.label}`
								: ''
						"
						v-if="item.type == 'input' && !item.addcomma"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						:maxlength="item.maxlength"
					>
						<template slot="prepend" v-if="item.prepend">{{
							item.prepend
						}}</template>
						<template slot="append" v-if="item.append">{{
							item.append
						}}</template>
					</el-input>
					<el-input
						v-model="recordToEdit[item.key]"
						:placeholder="
							item.disabled
								? ''
								: item.palceholderTitleChange
								? item.palceholderTitleChange
								: item.placeholder
								? item.placeholder
								: item.label
								? `請輸入${item.label}`
								: ''
						"
						v-if="item.type == 'input' && item.addcomma"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						v-on:input="
							resetInput(recordToEdit[item.key], item.key)
						"
					>
						<template slot="prepend" v-if="item.prepend">{{
							item.prepend
						}}</template>
						<template slot="append" v-if="item.append">{{
							item.append
						}}</template>
					</el-input>
					<!--  //隨機密碼 -->
					<el-input
						v-model="recordToEdit[item.key]"
						:placeholder="
							item.placeholder
								? item.placeholder
								: item.label
								? `請輸入${item.label}`
								: ''
						"
						v-if="item.type == 'randomPasswordNum'"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
					>
						<template slot="prepend" v-if="item.prepend">{{
							item.prepend
						}}</template>
						<template slot="append" v-if="item.append">{{
							item.append
						}}</template>
					</el-input>
					<!-- inputrange -->
					<div v-if="item.type == 'inputrange'">
						<el-input
							v-model="recordToEdit[item.key[0]]"
							:placeholder="
								item.placeholder
									? item.placeholder
									: item.label
									? `請輸入${item.label}`
									: ''
							"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							class="w200"
						></el-input
						>~
						<el-input
							v-model="recordToEdit[item.key[1]]"
							:placeholder="
								item.placeholder
									? item.placeholder
									: item.label
									? `請輸入${item.label}`
									: ''
							"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							class="w200"
						></el-input>
					</div>
					<!-- select 回傳 object -->
					<el-select
						v-model="recordToEdit[item.key]"
						:placeholder="
							item.label
								? `請選擇${item.label}`
								: item.placeholder
								? item.placeholder
								: ''
						"
						v-if="
							item.type == 'select' && item.returnType == 'object'
						"
						:value-key="
							item.options[0] && item.options[0].value
								? 'value'
								: 'id'
						"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						:filterable="item.filterable"
						@visible-change="handleSelectDropdownToggle"
					>
						<el-option
							:label="
								option.label
									? option.label
									: option.name
									? option.name
									: option.accountName
									? option.accountName
									: option
							"
							:value="option"
							v-for="(option, index) in item.options"
							:key="index"
							:disabled="option.disabled"
						></el-option>
					</el-select>
					<!-- select -->
					<div v-else-if="item.type == 'select'">
						<el-select
							v-model="recordToEdit[item.key]"
							:placeholder="
								item.label
									? `請選擇${item.label}`
									: item.placeholder
									? item.placeholder
									: ''
							"
							:value-key="item.valueKey ? item.valueKey : 'id'"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							:filterable="item.filterable"
							@visible-change="handleSelectDropdownToggle"
						>
							<el-option
								:label="
									item.labelValue
										? option[item.labelValue]
										: option.label
										? option.label
										: option.name
										? option.name
										: option.accountName
										? option.accountName
										: option
								"
								:value="
									item.value
										? option[item.value]
										: option.value
										? option.value
										: option.id
										? option.id
										: Number(index)
								"
								v-for="(option, index) in item.options"
								:key="index"
								:disabled="option.disabled"
							></el-option>
						</el-select>
						<el-input
							v-model="
								recordToEdit[
									item.options[item.options.length - 1] &&
										item.options[item.options.length - 1]
											.inputKey
								]
							"
							v-if="
								item.options[item.options.length - 1] &&
								item.options[item.options.length - 1]
									.inputKey &&
								item.options[item.options.length - 1].id ==
									recordToEdit[item.key]
							"
							style="margin-left: 10px; width: 100px"
						></el-input>
					</div>
					<div v-else-if="item.type == 'remoteselect'">
						<el-select
							v-model="recordToEdit[item.key]"
							:placeholder="
								item.placeholder ? item.placeholder : ''
							"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							:filterable="item.filterable"
							@visible-change="handleSelectDropdownToggle"
							:remote="item.remote"
							:remote-method="(data) => remoteQuery(data, index)"
							:loading="loading"
							reserve-keyword
						>
							<el-option
								v-for="(option, index) in item.options"
								:label="option.label"
								:value="option.value"
								:key="index"
								:disabled="option.disabled"
							></el-option>
						</el-select>
						<el-input
							v-model="
								recordToEdit[
									item.options[item.options.length - 1] &&
										item.options[item.options.length - 1]
											.inputKey
								]
							"
							v-if="
								item.options[item.options.length - 1] &&
								item.options[item.options.length - 1]
									.inputKey &&
								item.options[item.options.length - 1].id ==
									recordToEdit[item.key]
							"
							style="margin-left: 10px; width: 100px"
						></el-input>
					</div>
					<!-- chooseMember -->
					<div v-else-if="item.type == 'chooseMember'">
						<el-input
							v-model="chooseMember[item.key].showLabel"
							:placeholder="
								item.placeholder
									? item.placeholder
									: '請選擇社員'
							"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							@focus="openMember(item.key)"
							class="w250"
							:clearable="item.isclear"
							@clear="clear(chooseMember[item.key], item.key)"
							v-if="chooseMember[item.key]"
						></el-input>
						<el-dialog
							title="選擇社員"
							:visible.sync="dialogMember[item.key]"
							:modal-append-to-body="false"
							:append-to-body="true"
							width="660px"
						>
							<workbench
								:api="item.api ? item.api : 'member'"
								:query="item.query"
								:filter="
									item.filter ? item.filter : memberFilter
								"
								:columns="item.columns ? item.columns : columns"
								:toolbar="memberDialogToolbar"
								@editData="
									(id, row) => {
										clickMember(
											id,
											row,
											item,
											'key',
											'recordToEdit'
										);
									}
								"
								@addData="clickMember"
							></workbench>
						</el-dialog>
					</div>
					<!-- 社員多選 -->
					<div v-else-if="item.type == 'chooseMemberMultiple'">
						<el-select
							v-model="chooseMemberMultipleTitle[item.key]"
							multiple
							filterable
							allow-create
							popper-class="menuHide"
							default-first-option
							:automatic-dropdown="false"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							placeholder="選擇社員"
							@focus="openMultipleMember(item.key)"
							@remove-tag="removeItem(item.key)"
						>
							<!-- <el-option v-for="item in chooseMemberMultipleTitle"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value">
                            </el-option>-->
						</el-select>
						<el-dialog
							title="選擇社員"
							:visible.sync="dialogMultipleMember[item.key]"
							:modal-append-to-body="false"
							:append-to-body="true"
							width="660px"
						>
							<workbench
								:api="item.api ? item.api : 'member'"
								:query="item.query"
								:filter="
									item.filter ? item.filter : memberFilter
								"
								:columns="item.columns ? item.columns : columns"
								:toolbar="toolbar"
								:checkClick="recordToEdit[item.key]"
								@editData="
									(id, row) => {
										clickMultiple(id, row, item, item.key);
									}
								"
								@addData="clickMultiple"
							></workbench>
						</el-dialog>
					</div>
					<!-- chooseMemberRange -->
					<div v-else-if="item.type == 'chooseMemberRange'">
						<el-input
							v-model="chooseMember[item.key[0]].showLabel"
							:placeholder="
								item.placeholder
									? item.placeholder
									: '請選擇社員'
							"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							@focus="openMember(item.key, 0)"
							class="w250"
						></el-input
						>~
						<el-input
							v-model="chooseMember[item.key[1]].showLabel"
							:placeholder="
								item.placeholder
									? item.placeholder
									: '請選擇社員'
							"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							@focus="openMember(item.key, 1)"
							class="w250"
						></el-input>
						<el-dialog
							title="選擇社員"
							:visible.sync="dialogMember[item.key]"
							:modal-append-to-body="false"
							:append-to-body="true"
							width="660px"
						>
							<workbench
								:api="item.api ? item.api : 'member'"
								:query="item.query"
								:filter="
									item.filter ? item.filter : memberFilter
								"
								:columns="item.columns ? item.columns : columns"
								:toolbar="toolbar"
								@editData="
									(id, row) => {
										clickMember(
											id,
											row,
											item,
											'key',
											'recordToEdit'
										);
									}
								"
								@addData="clickMember"
								ref="member"
							></workbench>
						</el-dialog>
					</div>
					<!-- 出生地 -->
					<el-select
						v-model="recordToEdit[item.key]"
						:placeholder="
							item.label
								? `請選擇${item.label}`
								: item.placeholder
								? item.placeholder
								: ''
						"
						@change="
							(v) => {
								$emit('itemChange', v);
							}
						"
						v-if="item.type == 'birthcountry'"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						:filterable="item.filterable"
					>
						<el-option
							:label="
								option.label
									? option.label
									: option.name
									? option.name
									: option.accountName
									? option.accountName
									: option
							"
							:value="
								item.value
									? option[item.value]
									: option.value
									? option.value
									: option.id
									? option.id
									: Number(index)
							"
							v-for="(option, index) in countrys"
							:key="index"
							:disabled="option.disabled"
						></el-option>
					</el-select>
					<!-- 職業 -->
					<el-select
						v-model="recordToEdit[item.key]"
						:placeholder="
							item.label
								? `請選擇${item.label}`
								: item.placeholder
								? item.placeholder
								: ''
						"
						@change="
							(v) => {
								$emit('itemChange', v);
							}
						"
						v-if="item.type == 'jobselect'"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						:filterable="item.filterable"
					>
						<el-option
							:label="
								option.label
									? option.label
									: option.name
									? option.name
									: option.accountName
									? option.accountName
									: option
							"
							:value="
								item.value
									? option[item.value]
									: option.value
									? option.value
									: option.id
									? option.id
									: Number(index)
							"
							v-for="(option, index) in jobId"
							:key="index"
							:disabled="option.disabled"
						></el-option>
					</el-select>
					<!-- 介紹人選擇 -->
					<el-select
						v-model="recordToEdit[item.key]"
						:placeholder="
							item.label
								? `請選擇${item.label}`
								: item.placeholder
								? item.placeholder
								: ''
						"
						@change="
							(v) => {
								$emit('itemChange', v);
							}
						"
						v-if="item.type == 'selectmember'"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						:filterable="item.filterable"
					>
						<el-option
							:label="
								option.label
									? option.label
									: option.name
									? option.name
									: option.accountName
									? option.accountName
									: option
							"
							:value="
								item.value
									? option[item.value]
									: option.value
									? option.value
									: option.id
									? option.id
									: Number(index)
							"
							v-for="(option, index) in memberOptions"
							:key="index"
							:disabled="option.disabled"
						></el-option>
					</el-select>
					<el-select
						v-model="recordToEdit[item.key]"
						:placeholder="
							item.label
								? `請選擇${item.label}`
								: item.placeholder
								? item.placeholder
								: ''
						"
						@change="
							(v) => {
								$emit('itemChange', v);
							}
						"
						v-if="item.type == 'introducer1MemberId'"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						:filterable="item.filterable"
					>
						<el-option
							:label="
								option.label
									? option.label
									: option.name
									? option.name
									: option.accountName
									? option.accountName
									: option
							"
							:value="
								item.value
									? option[item.value]
									: option.value
									? option.value
									: option.id
									? option.id
									: Number(index)
							"
							v-for="(option, index) in jobId"
							:key="index"
							:disabled="option.disabled"
						></el-option>
					</el-select>
					<!-- select range 回傳 object -->
					<div
						v-else-if="
							item.type == 'selectrange' &&
							item.returnType == 'object'
						"
					>
						<el-select
							value-key="value"
							v-model="recordToEdit[item.key[0]]"
							:placeholder="
								item.label
									? `請選擇${item.label}`
									: item.placeholder
									? item.placeholder
									: ''
							"
							@change="
								(v) => {
									$emit('itemChange', v);
								}
							"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							:filterable="item.filterable"
						>
							<el-option
								:label="
									option.label
										? option.label
										: option.name
										? option.name
										: option
								"
								:value="option"
								v-for="(option, index) in item.options"
								:key="index"
							></el-option> </el-select
						>~
						<el-select
							value-key="value"
							v-model="recordToEdit[item.key[1]]"
							:placeholder="
								item.label
									? `請選擇${item.label}`
									: item.placeholder
									? item.placeholder
									: ''
							"
							@change="
								(v) => {
									$emit('itemChange', v);
								}
							"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							:filterable="item.filterable"
						>
							<el-option
								:label="
									option.label
										? option.label
										: option.name
										? option.name
										: option
								"
								:value="option"
								v-for="(option, index) in item.options"
								:key="index"
							></el-option>
						</el-select>
					</div>
					<!-- select range -->
					<div v-else-if="item.type == 'selectrange'">
						<el-select
							v-model="recordToEdit[item.key[0]]"
							:placeholder="
								item.label
									? `請選擇${item.label}`
									: item.placeholder
									? item.placeholder
									: ''
							"
							@change="
								(v) => {
									$emit('itemChange', v);
								}
							"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							:filterable="item.filterable"
						>
							<el-option
								:label="
									option.label
										? option.label
										: option.name
										? option.name
										: option
								"
								:value="
									item.value
										? option[item.value]
										: option.value
										? option.value
										: option.id
										? option.id
										: Number(index)
								"
								v-for="(option, index) in item.options"
								:key="index"
							></el-option> </el-select
						>~
						<el-select
							v-model="recordToEdit[item.key[1]]"
							:placeholder="
								item.label
									? `請選擇${item.label}`
									: item.placeholder
									? item.placeholder
									: ''
							"
							@change="
								(v) => {
									$emit('itemChange', v);
								}
							"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							:filterable="item.filterable"
						>
							<el-option
								:label="
									option.label
										? option.label
										: option.name
										? option.name
										: option
								"
								:value="
									item.value
										? option[item.value]
										: option.value
										? option.value
										: option.id
										? option.id
										: Number(index)
								"
								v-for="(option, index) in item.options"
								:key="index"
							></el-option>
						</el-select>
					</div>
					<!-- 多項 select -->
					<el-select
						v-model="recordToEdit[item.key]"
						:placeholder="
							item.label
								? `請選擇${item.label}`
								: item.placeholder
								? item.placeholder
								: ''
						"
						v-if="item.type == 'multiselect'"
						:value-key="item.valueKey ? item.valueKey : 'id'"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						multiple
						filterable
					>
						<el-option
							:label="option.label ? option.label : option.name"
							:value="option.value ? option.value : option.id"
							v-for="(option, index) in item.options"
							:key="index"
						></el-option>
					</el-select>
					<!-- 多層select -->
					<el-cascader
						:options="item.options"
						v-model="item.data"
						@change="
							(v) => {
								handleCascaderChange(v, item, 'recordToEdit');
							}
						"
						:props="{
							value:
								item.options[0] && item.options[0].value
									? 'value'
									: 'id',
							label:
								item.options[0] && item.options[0].label
									? 'label'
									: 'name',
						}"
						v-if="item.type == 'cascader'"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						filterable
						:class="item.key === 'jobId' ? 'job-cascader' : ''"
					></el-cascader>
					<!-- 多層select + 選擇框 -->
					<ele-multi-cascader
						:options="item.options"
						v-model="recordToEdit[item.key]"
						:placeholder="
							item.placeholder
								? item.placeholder
								: item.label
								? `請選擇${item.label}`
								: ''
						"
						:selectChildren="true"
						label-key="name"
						:value-key="item.valueKey ? item.valueKey : 'id'"
						panelWidth="auto"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						v-if="item.type == 'multicascader'"
					></ele-multi-cascader>
					<!-- year -->
					<!-- <el-date-picker v-model="recordToEdit[item.key]"
                        type="year"
                        placeholder="選擇年"
                        v-if="item.type == 'year'"
                        :disabled="item.disabled || (item.showNew && !(code == 'new' || id == 'new'))"
                        value-format="yyyy/MM/dd">
                    </el-date-picker>-->
					<!-- month -->
					<el-date-picker
						v-model="recordToEdit[item.key]"
						type="month"
						placeholder="選擇月"
						v-if="item.type == 'month'"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						value-format="yyyy/MM/dd"
					></el-date-picker>
					<!-- date 民國 -->
					<div
						v-if="item.type == 'date'"
						class="el-input el-input--prefix el-input--suffix custom-mingo-date"
					>
						<input
							type="text"
							autocomplete="off"
							class="el-input__inner min_go_date"
							:class="`${item.key + index} ${item.key}`"
							:disabled="
								item.disabled || (item.showNew && !(code == 'new' || id == 'new'))
							"
							placeholder="選擇日期"
							ref="datepicker"
						/>
						<span class="el-input__prefix">
							<i class="el-input__icon el-icon-date"></i>
						</span>
						<span
							class="el-input__suffix"
							v-if="item.isclear && recordToEdit[item.key] && !item.disabled"
						>
							<span class="el-input__suffix-inner">
								<i
									class="el-input__icon el-icon-circle-close clear-icon-hover"
									title="清除日期"
									@click="clearDate(item, index)"
								></i>
							</span>
						</span>
					</div>
					<!-- date -->
					<!-- <el-date-picker v-model="recordToEdit[item.key]"
                        type="date"
                        placeholder="選擇日期"
                        value-format="yyyy/MM/dd"
                        v-if="item.type == 'date'"
                        :disabled="item.disabled || (item.showNew && !(code == 'new' || id == 'new'))">
                    </el-date-picker>-->
					<!-- datetime 民國 -->
					<div v-if="item.type == 'datetime'">
						<input
							type="text"
							class="min_go_date"
							:class="`${item.key + index} ${item.key}`"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							placeholder="選擇日期"
						/>
						<span class="el-input__prefix" style="margin-left: 5px">
							<i class="el-icon-date"></i>
						</span>
						<el-time-picker
							v-model="datetime[item.key]"
							placeholder="選擇時間"
							value-format="HH:mm"
							format="HH:mm"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							class="ml10"
						></el-time-picker>
					</div>
					<!-- datetime -->
					<!-- <el-date-picker v-model="recordToEdit[item.key]"
                        type="datetime"
                        placeholder="選擇日期時間"
                        v-if="item.type == 'datetime'"
                        :disabled="item.disabled || (item.showNew && !(code == 'new' || id == 'new'))"
                        value-format="yyyy/MM/dd HH:mm"
                        format="yyyy/MM/dd HH:mm">
                    </el-date-picker>-->
					<!-- timerange -->
					<el-time-picker
						v-model="timerange"
						@change="
							(v) => {
								handleTimerangeChange(item, v);
							}
						"
						range-separator="~"
						start-placeholder="開始時間"
						end-placeholder="結束時間"
						placeholder="選擇時間範圍"
						value-format="HH:mm"
						v-if="item.type == 'timerange'"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						is-range
					></el-time-picker>
					<!-- daterange -->
					<!-- <el-date-picker v-model="recordToEdit[item.key]"
                        type="daterange"
                        range-separator="~"
                        start-placeholder="開始日期"
                        end-placeholder="結束日期"
                        :disabled="item.disabled || (item.showNew && !(code == 'new' || id == 'new'))"
                        value-format="yyyy/MM/dd"
                        format="yyyy/MM/dd"
                        v-if="item.type == 'daterange'">
                    </el-date-picker>-->
					<!-- datetimerange -->
					<!-- <el-date-picker v-model="recordToEdit[item.key]"
                        type="datetimerange"
                        range-separator="~"
                        start-placeholder="開始日期"
                        end-placeholder="結束日期"
                        v-if="item.type == 'datetimerange'"
                        :disabled="item.disabled || (item.showNew && !(code == 'new' || id == 'new'))"
                        value-format="yyyy/MM/dd HH:mm"
                        format="yyyy/MM/dd HH:mm">
                    </el-date-picker>-->
					<!-- switch -->
					<el-switch
						v-model="recordToEdit[item.key]"
						v-if="item.type == 'switch'"
						:active-text="item.active"
						:inactive-text="item.inactive"
						:active-value="1"
						:inactive-value="0"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
					></el-switch>
					<!-- checkbox 多個 array
                         display: 'inherit' 可直的排列
                    inputKey: 'other' 設定其他選項裡的input 的key 值-->
					<el-checkbox-group
						v-model="recordToEdit[item.key]"
						v-if="
							item.type == 'checkboxGroup' &&
							item.options &&
							item.options.length > 0
						"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
					>
						<el-checkbox
							:label="option.id ? option.id : option.value"
							name="type"
							v-for="(option, idx) in item.options"
							:key="idx"
							:class="{ inherit: item.display == 'inherit' }"
						>
							<span>{{
								option.name
									? option.name
									: option.label
									? option.label
									: option.docName
							}}</span>
							<el-input
								v-model="recordToEdit[option.inputKey]"
								v-if="option.inputKey"
								:disabled="option.disabled"
								style="margin-left: 10px; width: 100px"
							></el-input>
						</el-checkbox>
					</el-checkbox-group>
					<!-- checkbox 為 object -->
					<!-- <el-checkbox-group v-model="recordToEdit[item.key]"
                        v-else-if="item.type == 'checkboxGroup' && item.options && Object.keys(item.options).length !== 0"
                        :disabled="item.disabled || (item.showNew && !(code == 'new' || id == 'new'))">
                        <el-checkbox :label="idx"
                            v-for="(option, idx) in item.options"
                            :key="idx"
                            :class="{ inherit: item.display == 'inherit' }">
                            <span>{{option}}</span>
                        </el-checkbox>
                    </el-checkbox-group>-->
					<!-- checkbox 單一個 
                    有 trueValue falseValue 定義勾選即沒勾選的值-->
					<el-checkbox
						v-model="recordToEdit[item.key]"
						:label="item.options[0].label"
						:true-label="
							item.options[0].trueValue
								? item.options[0].trueValue
								: 1
						"
						:false-label="
							item.options[0].falseValue
								? item.options[0].falseValue
								: 0
						"
						name="type"
						v-if="item.type == 'checkbox'"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
					></el-checkbox>
					<!-- radio 為 array
                    inputKey: 'other' 設定其他選項裡的input 的key 值-->
					<!-- 資料欄位同某個欄位 -->
					<el-checkbox
						v-model="recordToEdit[item.key]"
						:label="item.options[0].label"
						:true-label="
							item.options[0].trueValue
								? item.options[0].trueValue
								: 1
						"
						:false-label="
							item.options[0].falseValue
								? item.options[0].falseValue
								: 0
						"
						name="type"
						v-if="item.type == 'checkboxSandToTop'"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
						@change="(v) => {
							handleCheckboxSandToTopChange(index, v);
						}"
					></el-checkbox>
					<!-- radio 有其他選項 -->
					<el-radio-group
						v-model="recordToEdit[item.key]"
						v-if="
							item.type == 'radio' &&
							item.options &&
							item.options.length > 0
						"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
					>
						<el-radio
							:label="option.value"
							v-for="(option, idx) in item.options"
							:key="idx"
							:class="{ flex: item.display == 'flex' }"
						>
							<span>{{ option.label }}</span>
							<el-input
								v-model="recordToEdit[option.inputKey]"
								v-if="option.inputKey"
								:disabled="option.disabled"
								style="margin-left: 10px; width: 100px"
							></el-input>
						</el-radio>
					</el-radio-group>
					<!-- radio 為 object -->
					<el-radio-group
						v-model="recordToEdit[item.key]"
						v-else-if="
							item.type == 'radio' &&
							item.options &&
							Object.keys(item.options).length !== 0
						"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
					>
						<el-radio
							:label="Number(idx)"
							v-for="(option, idx) in item.options"
							:key="idx"
							>{{ option }}</el-radio
						>
					</el-radio-group>
					<!-- radio 單純是否 -->
					<el-radio-group
						v-model="recordToEdit[item.key]"
						v-else-if="item.type == 'radio'"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
					>
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
					<!-- textarea -->
					<div>
						<!-- textarea 外層使用一個div包起來 如果有切畫面可能會導致沒綁定到參數 -->
						<!-- 有vhtml 參數 單純渲染 -->
						<p
							v-if="item.type == 'textarea' && item.vhtml"
							v-html="recordToEdit[item.key]"
						></p>
						<el-input
							type="textarea"
							v-model="recordToEdit[item.key]"
							:rows="4"
							v-else-if="item.type == 'textarea'"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
						></el-input>
					</div>
					<!-- number -->
					<el-input-number
						v-model="recordToEdit[item.key]"
						@change="handleChange"
						:min="item.min"
						:max="item.max"
						label="描述文字"
						v-if="item.type == 'number' && !item.addcomma"
						:disabled="
							item.disabled ||
							(item.showNew && !(code == 'new' || id == 'new'))
						"
					></el-input-number>
					<!-- 選擇使用者 對照email 多選
                         target: 'admin'  協會管理員
                    target: 'member' 儲互社社員-->
					<div v-if="item.type == 'email'">
						<el-checkbox
							label="使用 email 通知"
							v-model="recordToEdit[item.setting]"
							:true-label="1"
							:false-label="0"
						></el-checkbox>
						<br />
						<label for="message" class="el-form-item__label"
							>email 通知對象</label
						>
						<br />
						<!-- admin -->
						<el-select
							v-model="recordToEdit[item.key]"
							multiple
							filterable
							placeholder="請選擇系統使用者"
							v-if="item.target == 'admin'"
							style="width: 100%"
						>
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
						<!-- member -->
						<el-select
							v-model="recordToEdit[item.key]"
							multiple
							filterable
							placeholder="請選擇社員"
							v-if="item.target == 'member'"
							style="width: 100%"
						>
							<el-option
								v-for="item in options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</div>
					<!-- 選擇使用者 對照簡訊 多選
                    target 為對象 有 admin 及 member-->
					<div v-if="item.type == 'sms'">
						<el-checkbox
							label="使用 簡訊 通知"
							v-model="recordToEdit[item.setting]"
							:true-label="1"
							:false-label="0"
						></el-checkbox>
						<br />
						<label for="message" class="el-form-item__label"
							>簡訊 通知對象</label
						>
						<br />
						<!-- admin -->
						<el-select
							v-model="recordToEdit[item.key]"
							multiple
							filterable
							placeholder="請選擇系統使用者"
							v-if="item.target == 'admin'"
							style="width: 100%"
						>
							<el-option
								v-for="item of options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
						<!-- member -->
						<el-select
							v-model="recordToEdit[item.key]"
							multiple
							filterable
							placeholder="請選擇社員"
							v-if="item.target == 'member'"
							style="width: 100%"
						>
							<el-option
								v-for="item of options"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							></el-option>
						</el-select>
					</div>
					<!-- 地址
                    欄位都相對寫死-->
					<div v-if="item.type == 'address'" class="address">
						<el-cascader
							:options="countrys"
							@change="
								(v) => {
									handleCountryChange(item, v);
								}
							"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							filterable
							:placeholder="`請選擇縣市區域`"
							:props="defaultProps"
							v-model="address[item.key]"
						></el-cascader>
						<el-input
							v-model="recordToEdit[item.key + 'Zipcode']"
							:placeholder="`請輸入郵遞區號`"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							style="
								margin-top: 10px;
								width: 200px;
								margin-left: 10px;
							"
						></el-input>
						<!-- {{Zipcode[item.key]}} -->
						<el-input
							v-model="recordToEdit[item.key + 'Street']"
							:placeholder="`請輸入${item.label}的街道門牌`"
							:disabled="
								item.disabled ||
								(item.showNew &&
									!(code == 'new' || id == 'new'))
							"
							@blur="addressHandler"
							style="margin-top: 10px"
							@change="handleAddressChange(item)"
						></el-input>
					</div>
					<!-- editor -->
					<div v-if="item.type == 'editor'">
						<!-- 插入欄位 -->
						<el-select
							:placeholder="`請選擇插入欄位`"
							:disabled="item.disabled"
							style="margin-bottom: 10px; margin-right: 10px"
							v-if="item.insert"
							v-model="insertColumn"
						>
							<el-option
								:label="option.label"
								:value="option.value"
								v-for="(option, idx) in item.insert"
								:key="idx"
							></el-option>
						</el-select>
						<el-button
							@click="insertEditor(item, index)"
							:disabled="item.disabled"
							v-if="item.insert"
							style="margin-bottom: 10px"
							>插入</el-button
						>
						<quill-editor
							v-model="recordToEdit[item.key]"
							:ref="`myQuillEditor${index}`"
							:options="editorOption"
							@blur="onEditorBlur($event, index)"
							@change="onEditorChange($event, index)"
							@focus="onEditorFocus($event, index)"
							@ready="onEditorReady($event, index)"
						></quill-editor>
					</div>
					<!-- upload -->
					<el-upload
						class="upload-demo"
						action
						:on-preview="handlePreview"
						:on-remove="
							(file, fileList) =>
								handleRemove(file, fileList, index)
						"
						:before-upload="beforeUpload"
						:before-remove="beforeRemove"
						multiple
						:limit="item.limit"
						:file-list="item.fileList"
						:http-request="(e) => upload(e, index)"
						accept=".pdf"
						v-if="item.type == 'upload'"
					>
						<el-button type="primary" plain>{{
							item.button ? item.button : "點擊上傳"
						}}</el-button>
					</el-upload>
					<!-- 次標題 -->
					<div v-if="item.type == 'title'" class="title-border">
						<h3>
							<strong>{{ item.title }}</strong>
						</h3>
					</div>
					<!-- span -->
					<span v-if="item.type == 'span'" :class="item.class" v-html="item.span"></span>
					<!-- button
                         button: 按鈕名稱,
                         buttonType: 按鈕類型,
                    buttonKey: 按鈕emit事件-->
					<el-button
						:type="item.buttonType"
						@click="$emit(item.buttonKey)"
						:class="item.btnClass"
						v-if="
							item.type == 'button' &&
							((item.showNew && id == 'new') || !item.showNew) &&
							item.vif !== false
						"
						v-show="item.vshow !== false"
						:plain="item.plain"
						>{{ item.button }}</el-button
					>
					<!-- list -->
					<div v-if="item.type == 'list'">
						<el-button
							type="success"
							size="mini"
							:disabled="
								item.addbtndisabled
									? item.addbtndisabled
									: false
							"
							@click="addList(index)"
							v-if="item.toolbar && item.toolbar.add"
							>新增</el-button
						>
						<el-table
							ref="table"
							:data="item.data"
							max-height="800"
							@selection-change="handleSelectionChange"
						>
							<el-table-column
								type="index"
								align="center"
								width="50"
								fixed
							></el-table-column>
							<el-table-column
								align="center"
								width="140"
								v-if="item.toolbar && item.toolbar.edit"
							>
								<template slot-scope="scope">
									<el-button
										type="success"
										icon="el-icon-edit"
										size="mini"
										@click="
											editList(
												scope.row,
												scope.$index,
												index
											)
										"
									></el-button>
									<el-button
										type="danger"
										icon="el-icon-delete"
										size="mini"
										@click="removeList(index, scope.$index)"
									></el-button>
								</template>
							</el-table-column>
							<!-- <el-table-column v-for="col of item.columns"
                                             v-if="col.listIf !== false"
                                             :prop="col.prop"
                                             :label="col.label"
                                             :show-overflow-tooltip="true"
                                             :highlight-current-row="true"
                            :key="col.label"></el-table-column>-->
							<el-table-column
								v-for="col of item.columns"
								v-if="col.listIf !== false"
								:prop="col.prop"
								:label="col.label"
								:show-overflow-tooltip="true"
								:highlight-current-row="true"
								:key="col.label"
								v-bind="col"
							>
								<template slot-scope="scope">
									<custom-row
										:scope="scope"
										:renderFunction="col.renderFunction"
										:enumData="enumData"
										v-if="col.renderFunction"
									></custom-row>
									<div v-else>{{ scope.row[col.prop] }}</div>
								</template>
							</el-table-column>
						</el-table>
						<el-dialog
							:title="item.title"
							:visible.sync="dialogListForm"
							:append-to-body="true"
							:modal-append-to-body="false"
							v-if="
								item.toolbar &&
								item.toolbar.add &&
								dialogListForm
							"
						>
							<el-form :model="currentEdit" ref="currentEdit" label-position="top">
								<el-form-item
									:label="form.label"
									v-for="form in item.columns"
									:key="form.prop"
									v-if="
										form.prop !== 'updateTime' &&
										form.prop !== 'updateUserName' &&
										form.vif !== false
									"
									v-show="form.vshow !== false"
								>
									<!-- radio 為 array
                                    inputKey: 'other' 設定其他選項裡的input 的key 值-->
									<!-- radio 有其他選項 -->
									<el-radio-group
										v-model="currentEdit[form.prop]"
										v-if="
											form.type == 'radio' &&
											form.options &&
											form.options.length > 0 &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
										:disabled="form.disabled"
									>
										<el-radio
											:label="option.value"
											v-for="(
												option, idx
											) in form.options"
											:key="idx"
										>
											<span>{{ option.label }}</span>
											<el-input
												v-model="
													recordToEdit[
														option.inputKey
													]
												"
												v-if="option.inputKey"
												:disabled="option.disabled"
												style="
													margin-left: 10px;
													width: 100px;
												"
											></el-input>
										</el-radio>
									</el-radio-group>
									<!-- radio 為 object -->
									<el-radio-group
										v-model="currentEdit[form.prop]"
										v-else-if="
											form.type == 'radio' &&
											form.options &&
											Object.keys(form.options).length !==
												0 &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
										:disabled="form.disabled"
									>
										<el-radio
											:label="Number(idx)"
											v-for="(
												option, idx
											) in form.options"
											:key="idx"
											>{{ option }}</el-radio
										>
									</el-radio-group>
									<!-- radio 單純是否 -->
									<el-radio-group
										v-model="currentEdit[form.prop]"
										v-else-if="
											form.type == 'radio' &&
											form.vif !== false
										"
										:disabled="form.disabled"
									>
										<el-radio :label="1">是</el-radio>
										<el-radio :label="0">否</el-radio>
									</el-radio-group>
									<!-- checkbox 單一個 
                                    有 trueValue falseValue 定義勾選即沒勾選的值-->
									<el-checkbox
										v-model="currentEdit[form.prop]"
										:label="form.options[0].label"
										:true-label="
											form.options[0].trueValue
												? form.options[0].trueValue
												: 1
										"
										:false-label="
											form.options[0].falseValue
												? form.options[0].falseValue
												: 0
										"
										name="type"
										v-else-if="
											form.type == 'checkbox' &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
										:disabled="form.disabled"
									></el-checkbox>
									<!-- chooseMember -->
									<div
										v-else-if="
											form.type == 'chooseMember' &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
									>
										<el-input
											v-model="
												chooseMember[form.prop]
													.showLabel
											"
											:placeholder="
												form.placeholder
													? form.placeholder
													: '請選擇社員'
											"
											:disabled="form.disabled"
											@focus="openMember(form.prop)"
											class="w250"
											:clearable="form.isclear"
											@clear="
												clear(
													chooseMember[form.prop],
													form.prop
												)
											"
										></el-input>
										<el-dialog
											title="選擇社員"
											:visible.sync="
												dialogMember[form.prop]
											"
											:modal-append-to-body="false"
											:append-to-body="true"
											width="660px"
										>
											<workbench
												:api="
													form.api
														? form.api
														: 'member'
												"
												:query="form.query"
												:filter="
													form.filter
														? form.filter
														: memberFilter
												"
												:columns="
													form.columns
														? form.columns
														: columns
												"
												:toolbar="toolbar"
												@editData="
													(id, row) => {
														clickMember(
															id,
															row,
															form,
															'prop',
															'currentEdit'
														);
													}
												"
												@addData="clickMember"
												ref="member"
											></workbench>
										</el-dialog>
									</div>
									<!-- select value 回傳 object -->
									<el-select
										v-model="currentEdit[form.prop]"
										value-key="id"
										:placeholder="
											form.label
												? `請選擇${form.label}`
												: form.placeholder
												? form.placeholder
												: ''
										"
										@change="
											(v) => {
												$emit('itemChange', v);
											}
										"
										v-else-if="
											form.type == 'select' &&
											form.returnType == 'object' &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
										:disabled="
											form.disabled ||
											(form.showNew && id !== 'new')
										"
										:filterable="form.filterable"
									>
										<el-option
											:label="
												option.label
													? option.label
													: option.name
													? option.name
													: option.accountName
													? option.accountName
													: option
											"
											:value="option"
											v-for="(
												option, index
											) in form.options"
											:key="index"
											:disabled="option.disabled"
										></el-option>
									</el-select>
									<!-- select -->
									<el-select
										v-model="currentEdit[form.prop]"
										:placeholder="
											form.label
												? `請選擇${form.label}`
												: form.placeholder
												? form.placeholder
												: ''
										"
										@change="
											(v) => {
												$emit('itemChange', v);
											}
										"
										v-else-if="
											form.type == 'select' &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
										:disabled="
											form.disabled ||
											(form.showNew && id !== 'new')
										"
										:filterable="form.filterable"
									>
										<el-option
											:label="
												option.label
													? option.label
													: option.name
													? option.name
													: option.accountName
													? option.accountName
													: option
											"
											:value="
												form.value
													? option[form.value]
													: option.value
													? option.value
													: option.id
													? option.id
													: Number(index)
											"
											v-for="(
												option, index
											) in form.options"
											:key="index"
											:disabled="option.disabled"
										></el-option>
									</el-select>
									<!-- cascader -->
									<el-cascader
										:options="form.options"
										v-model="form.data"
										@change="
											(v) => {
												handleCascaderChange(
													v,
													form,
													'currentEdit'
												);
											}
										"
										:props="{
											value:
												form.options[0] &&
												form.options[0].value
													? 'value'
													: 'id',
											label:
												form.options[0] &&
												form.options[0].label
													? 'label'
													: 'name',
										}"
										v-else-if="
											form.type == 'cascader' &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
										:disabled="form.disabled"
										filterable
									></el-cascader>
									<!-- date -->
									<el-date-picker
										v-model="currentEdit[form.prop]"
										type="date"
										placeholder="選擇日期"
										value-format="yyyy/MM/dd"
										v-else-if="
											form.type == 'date' &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
										:disabled="
											form.disabled ||
											(form.showNew &&
												!(code == 'new' || id == 'new'))
										"
									></el-date-picker>
									<!-- textarea -->
									<p
										v-else-if="
											form.type == 'textarea' &&
											form.vhtml
										"
										v-html="currentEdit[form.prop]"
									></p>
									<el-input
										type="textarea"
										v-model="currentEdit[form.prop]"
										:rows="4"
										v-else-if="
											form.type == 'textarea' &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
										:disabled="
											form.disabled ||
											(form.showNew &&
												!(code == 'new' || id == 'new'))
										"
									></el-input>
									<!-- 預設 input -->
									<el-input
										v-model="currentEdit[form.prop]"
										:disabled="
											form.disabled
												? form.disabled
												: false
										"
										v-else-if="
											form.type == 'input' &&
											form.addcomma &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
										v-on:input="
											resetEditAmount(
												currentEdit[form.prop],
												form.prop
											)
										"
									></el-input>
									<!-- 預設 input -->
									<el-input
										v-model="currentEdit[form.prop]"
										:disabled="
											form.disabled
												? form.disabled
												: false
										"
										v-else-if="form.vif !== false"
										v-show="form.vshow !== false"
									></el-input>
								</el-form-item>
							</el-form>
							<div slot="footer" class="dialog-footer">
								<el-button @click="dialogListForm = false"
									>取消</el-button
								>
								<el-button
									type="primary"
									@click="saveDialogEdit(index)"
									>確定</el-button
								>
							</div>
						</el-dialog>
					</div>
					<!-- listMultiple -->
					<div v-if="item.type == 'listMultiple'">
						<el-button
							type="success"
							size="mini"
							:disabled="
								item.addbtndisabled
									? item.addbtndisabled
									: false
							"
							@click="addListMul(index, item.key)"
							v-if="item.toolbar && item.toolbar.add"
							>新增</el-button
						>
						<el-table
							ref="table"
							:data="item.data"
							max-height="800"
							@selection-change="handleSelectionChange"
						>
							<el-table-column
								type="index"
								align="center"
								width="50"
								fixed
							></el-table-column>
							<el-table-column
								align="center"
								width="140"
								v-if="item.toolbar && item.toolbar.edit"
							>
								<template slot-scope="scope">
									<el-button
										type="success"
										icon="el-icon-edit"
										size="mini"
										@click="
											editListMutiple(
												scope.row,
												scope.$index,
												item.key
											)
										"
									></el-button>
									<el-button
										type="danger"
										icon="el-icon-delete"
										size="mini"
										v-if="
											item.toolbar && item.toolbar.remove
										"
										@click="
											removeListMul(
												index,
												scope.$index,
												item.key
											)
										"
									></el-button>
								</template>
							</el-table-column>
							<el-table-column
								v-for="col of item.columns"
								v-if="col.listIf !== false"
								:prop="col.prop"
								:label="col.label"
								:show-overflow-tooltip="true"
								:highlight-current-row="true"
								:key="col.label"
							>
								<template slot-scope="scope">
									<custom-row
										:scope="scope"
										:renderFunction="col.renderFunction"
										v-if="col.renderFunction"
									></custom-row>
									<div v-else>{{ scope.row[col.prop] }}</div>
								</template>
							</el-table-column>
						</el-table>
						<el-dialog
							:title="item.title"
							:visible.sync="dialogListFormMultiple[item.key]"
							:append-to-body="true"
							:modal-append-to-body="false"
							v-if="item.toolbar && item.toolbar.add"
						>
							<el-form
								:model="currentEditMultiple[item.key]"
								ref="currentEdit"
								label-position="top"
							>
								<el-form-item
									:label="form.label"
									v-for="form in item.columns"
									:key="form.prop"
									v-if="
										form.prop !== 'updateTime' &&
										form.prop !== 'updateUserName' &&
										form.vif !== false
									"
									v-show="form.vshow !== false"
								>
									<!-- radio 為 array
                                    inputKey: 'other' 設定其他選項裡的input 的key 值-->
									<!-- radio 有其他選項 -->
									<el-radio-group
										v-model="
											currentEditMultiple[item.key][
												form.prop
											]
										"
										v-if="
											form.type == 'radio' &&
											form.options &&
											form.options.length > 0 &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
										:disabled="form.disabled"
									>
										<el-radio
											:label="option.value"
											v-for="(
												option, idx
											) in form.options"
											:key="idx"
										>
											<span>{{ option.label }}</span>
											<el-input
												v-model="
													recordToEdit[
														option.inputKey
													]
												"
												v-if="option.inputKey"
												:disabled="option.disabled"
												style="
													margin-left: 10px;
													width: 100px;
												"
											></el-input>
										</el-radio>
									</el-radio-group>
									<!-- radio 為 object -->
									<el-radio-group
										v-model="
											currentEditMultiple[item.key][
												form.prop
											]
										"
										v-else-if="
											form.type == 'radio' &&
											form.options &&
											Object.keys(form.options).length !==
												0 &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
										:disabled="form.disabled"
									>
										<el-radio
											:label="Number(idx)"
											v-for="(
												option, idx
											) in form.options"
											:key="idx"
											>{{ option }}</el-radio
										>
									</el-radio-group>
									<!-- radio 單純是否 -->
									<el-radio-group
										v-model="
											currentEditMultiple[item.key][
												form.prop
											]
										"
										v-else-if="
											form.type == 'radio' &&
											form.vif !== false
										"
										v-show="form.vshow !== false"
										:disabled="form.disabled"
									>
										<el-radio :label="1">是</el-radio>
										<el-radio :label="0">否</el-radio>
									</el-radio-group>
									<!-- upload -->
									<el-upload
										class="upload-demo"
										action
										:on-preview="handlePreview"
										:on-remove="handleRemove"
										:before-upload="beforeUpload"
										:before-remove="beforeRemove"
										multiple
										:limit="form.limit"
										:file-list="form.fileList"
										:http-request="upload"
										v-else-if="form.type == 'upload'"
									>
										<el-button type="primary"
											>點擊上傳</el-button
										>
									</el-upload>
									<!-- select value 回傳 object -->
									<el-select
										v-model="
											currentEditMultiple[item.key][
												form.prop
											]
										"
										value-key="id"
										:placeholder="
											form.label
												? `請選擇${form.label}`
												: form.placeholder
												? form.placeholder
												: ''
										"
										@change="
											(v) => {
												$emit('itemChange', v);
											}
										"
										v-else-if="
											form.type == 'select' &&
											form.returnType == 'object'
										"
										:disabled="
											form.disabled ||
											(form.showNew && id !== 'new')
										"
										:filterable="form.filterable"
									>
										<el-option
											:label="
												option.label
													? option.label
													: option.name
													? option.name
													: option.accountName
													? option.accountName
													: option
											"
											:value="option"
											v-for="(
												option, index
											) in form.options"
											:key="index"
											:disabled="option.disabled"
										></el-option>
									</el-select>
									<!-- select -->
									<el-select
										v-model="
											currentEditMultiple[item.key][
												form.prop
											]
										"
										:placeholder="
											form.label
												? `請選擇${form.label}`
												: form.placeholder
												? form.placeholder
												: ''
										"
										@change="
											(v) => {
												$emit('itemChange', v);
											}
										"
										v-else-if="form.type == 'select'"
										:disabled="
											form.disabled ||
											(form.showNew && id !== 'new')
										"
										:filterable="form.filterable"
									>
										<el-option
											:label="
												option.label
													? option.label
													: option.name
													? option.name
													: option.accountName
													? option.accountName
													: option
											"
											:value="
												form.value
													? option[form.value]
													: option.value
													? option.value
													: option.id
													? option.id
													: Number(index)
											"
											v-for="(
												option, index
											) in form.options"
											:key="index"
											:disabled="option.disabled"
										></el-option>
									</el-select>
									<!-- date -->
									<el-date-picker
										v-model="
											currentEditMultiple[item.key][
												form.prop
											]
										"
										type="date"
										placeholder="選擇日期"
										value-format="yyyy/MM/dd"
										v-else-if="form.type == 'date'"
										:disabled="
											form.disabled ||
											(form.showNew &&
												!(code == 'new' || id == 'new'))
										"
									></el-date-picker>
									<!-- textarea -->
									<p
										v-else-if="
											form.type == 'textarea' &&
											form.vhtml
										"
										v-html="
											currentEditMultiple[item.key][
												form.prop
											]
										"
									></p>
									<el-input
										type="textarea"
										v-model="
											currentEditMultiple[item.key][
												form.prop
											]
										"
										:rows="4"
										v-else-if="form.type == 'textarea'"
										:disabled="
											form.disabled ||
											(form.showNew &&
												!(code == 'new' || id == 'new'))
										"
									></el-input>
									<!-- 預設 input -->
									<el-input
										v-model="
											currentEditMultiple[item.key][
												form.prop
											]
										"
										:disabled="
											form.disabled
												? form.disabled
												: false
										"
										v-else
									></el-input>
								</el-form-item>
							</el-form>
							<div slot="footer" class="dialog-footer">
								<el-button
									@click="
										dialogListFormMultiple[item.key] = false
									"
									>取消</el-button
								>
								<el-button
									type="primary"
									@click="
										saveDialogEditMul(
											index,
											item.key,
											currentEditMultiple[item.key]
										)
									"
									>確定</el-button
								>
							</div>
						</el-dialog>
					</div>
					<!-- bussinesshours -->
					<div
						v-if="item.type == 'bussinesshours'"
						class="bussinesshours"
					>
						<div
							class="hour"
							v-for="(week, index) in weeks"
							:key="index"
						>
							{{ week }}
							<el-checkbox
								class="ml10"
								:true-label="1"
								:false-label="0"
								v-model="
									recordToEdit[item.key][index].notNeedWork
								"
								>不上班</el-checkbox
							>
							<el-time-picker
								is-range
								v-model="
									recordToEdit[item.key][index].timerange
								"
								@change="
									(v) => {
										handleBussinessHoursChange(
											recordToEdit[item.key][index],
											v
										);
									}
								"
								range-separator="~"
								start-placeholder="開始時間"
								end-placeholder="結束時間"
								placeholder="選擇時間範圍"
								format="HH:mm"
								value-format="H:m"
							></el-time-picker>
						</div>
					</div>
					<!-- 欄位設定 columns -->
					<el-table
						ref="multipleTable"
						:data="item.data"
						tooltip-effect="dark"
						style="width: 100%"
						@selection-change="
							(val) => {
								handleSelectionChange(item, val);
							}
						"
						v-if="item.type == 'columns'"
					>
						<el-table-column
							type="selection"
							width="55"
							label="顯示"
							:selectable="
								() => {
									return !item.disabled;
								}
							"
						></el-table-column>
						<el-table-column label="順序" width="120">
							<template slot-scope="scope">
								<el-button
									plain
									@click="handleClick(item, scope, 'up')"
									size="small"
									icon="el-icon-arrow-up"
									:disabled="
										scope.$index == 0 || item.disabled
									"
								></el-button>
								<el-button
									plain
									@click="handleClick(item, scope, 'down')"
									size="small"
									icon="el-icon-arrow-down"
									:disabled="
										scope.$index == item.data.length - 1 ||
										item.disabled
									"
								></el-button>
							</template>
						</el-table-column>
						<el-table-column
							prop="name"
							label="欄位名稱"
							width="120"
						></el-table-column>
						<el-table-column
							:label="item.append[0]"
							width="120"
							v-if="item.append"
						>
							<template slot-scope="scope">{{
								item.append[scope.$index + 1]
							}}</template>
						</el-table-column>
					</el-table>
					<!-- slot -->
					<slot :name="item.slot" v-if="item.type == 'slot'"></slot>
					<!-- hint 輸入框下方灰色小字；hint 為靜態文字，hintKey 取 recordToEdit 動態值 -->
					<div
						v-if="
							item.hint ||
							(item.hintKey && recordToEdit[item.hintKey])
						"
						class="form-item-hint"
					>
						{{ item.hint || recordToEdit[item.hintKey] }}
					</div>
				</el-form-item>
				<slot name="footer">
					<el-form-item>
						<el-button
							type="primary"
							@click="submitForm('recordToEdit')"
							>儲存</el-button
						>
						<el-button @click="back">取消</el-button>
					</el-form-item>
				</slot>
			</el-form>
		</div>
	</div>
</template>
<script>
/* eslint-disable */
import { API } from "@/assets/config";
import debounce from "lodash/debounce";
import Workbench from "@/components/Workbench";
import CustomRow from "@/components/CustomRow.vue";
import { datepickerTw } from "../assets/datepickerTW.js";
import datepickerFactory from "jquery-datepicker";
// datepickerFactory($);
export default {
	name: "list_form",
	components: { Workbench, CustomRow },
	props: {
		api: {
			type: String,
			default: "",
		},
		// 是否另外寫back function
		changeBack: {
			type: Boolean,
			default: false,
		},
		id: [Number, String],
		code: [Number, String],
		labelPosition: String,
		formTitle: String,
		subTitle: String,
		subBtn: {
			type: Array,
			default: function () {
				return [];
			},
		},
		subTime: {
			type: String,
			default: "",
		},
		rules: {
			type: Object,
			default: function () {
				return {};
			},
		},
		recordToEdit: {
			type: Object,
			default: function () {
				return {};
			},
		},
		formType: {
			type: Array,
			default: function () {
				return [];
			},
		},
		action: {
			type: String,
			default: "",
		},
		filter: {
			type: Object,
			default: function () {
				return {};
			},
		},
		enumData: {
			type: Object,
			default: function () {
				return {};
			},
		},
		columns: {
			type: Array,
			default: function () {
				return [
					{
						label: "社員帳號",
						prop: "account",
					},
					{
						label: "社員名稱",
						prop: "name",
					},
					{
						label: "社員類型",
						prop: "typeKey",
						renderFunction(h, scope, enumData) {
							return h(
								"div",
								enumData.memberTypeKey[scope.row.typeKey]
							);
						},
					},
					{
						label: "群組代號",
						prop: "memberGroupCode"
					},
					
				];
			},
		},
	},
	data() {
		return {
			// 社員名單
			memberOptions: [],
			// 系統使用者名單
			adminOptions: [],
			loading: false,
			// 社員名單
			options: [
				{
					value: 1,
					label: "黄金糕",
				},
				{
					value: 2,
					label: "双皮奶",
				},
				{
					value: 3,
					label: "蚵仔煎",
				},
				{
					value: 4,
					label: "龙须面",
				},
				{
					value: 5,
					label: "北京烤鸭",
				},
			],
			editorOption: {
				// some quill options
			},
			// 插入欄位
			insertColumn: "",
			// 縣市區域
			countrys: [],
			// 縣市區域是否呼叫
			countrysFlag: true,
			// 縣市區域配置選項
			defaultProps: {
				label: "name",
				value: "id",
			},
			// 郵遞區號
			Zipcode: {},
			// 地址
			address: {},
			jobId: {},
			// list 編輯的 modal
			dialogListForm: false,
			// list modal 正在編輯
			currentEdit: {},
			currentIndex: 0,
			// buniesshours 星期
			weeks: [
				"星期日",
				"星期一",
				"星期二",
				"星期三",
				"星期四",
				"星期五",
				"星期六",
			],
			// 民國 datetime 的 time
			datetime: {},
			// 時間範圍
			timerange: [],
			// 編輯器錨點 cursor position ex: 用編輯器index當作鍵
			cursorPosition: {},
			fileObj: {},
			file: null,
			// 選擇社員
			chooseMember: {},
			//多選的社員
			chooseMemberMultiple: [],
			chooseMemberMultipleTitle: [],
			// 選擇社員 dialog
			dialogMember: {},
			dialogMultipleMember: {},
			chooseMemberIndex: 0,
			checkMenu: [],
			currentEditMultiple: {},
			dialogListFormMultiple: [],
			// member workbench
			toolbar: {
				addable: false,
				removeable: false,
				select: false,
				pageQuery: true,
			},
			// 彈窗內選擇社員用的 toolbar，pageQuery: false 避免換頁時影響主頁面 URL；不顯示新增/刪除/跨頁全選
			memberDialogToolbar: {
				pageQuery: false,
				addable: false,
				removeable: false,
				select: false,
			},
			// 選擇社員 預設過濾社員
			memberFilter: {
				isFormal: 1,
			},
			//遠程搜尋選單的index
			remoteindex: {},
			// columns: [
			//     {
			//         label: "社員類型",
			//         prop: "typeKey",
			//         renderFunction(h, scope, enumData) {
			//             return h(
			//                 "div",
			//                 enumData.memberTypeKey[scope.row.typeKey]
			//             );
			//         }
			//     },
			//     {
			//         label: "社員帳號",
			//         prop: "account"
			//     },
			//     {
			//         label: "群組代號",
			//         prop: "memberGroupId",
			//         renderFunction(h, scope, enumData) {
			//             let result = "";
			//             enumData.memberGroup.forEach(element => {
			//                 if (scope.row.memberGroupId == element.id) {
			//                     result = element.name;
			//                 }
			//             });
			//             return h("div", result);
			//         }
			//     },
			//     {
			//         label: "社員名稱",
			//         prop: "name"
			//     }
			// ]
		};
	},
	watch: {
		recordToEdit: {
			handler: function (key) {
				this.formType.forEach((item, index) => {
					if (
						item.type == "chooseMember" &&
						this.recordToEdit[item.key] &&
						!this.dialogMember[item.key] &&
						item.returnKey !== "account" &&
						item.searchMember !== false
					) {
						// 有設定 chooseMember 的 透過 id 取得資料顯示在 recordToEdit 上
						this.getMemberById(this.recordToEdit[item.key], item);
					} else if (
						item.type == "checkboxSandToTop" &&
						this.recordToEdit[item.key] &&
						this.recordToEdit[item.key] == 1 &&
						// 是isAddress住址的時候
						item.isAddress
					) {
						this.handleAddress(item);
					} else if (item.type == "date") {
						setTimeout(() => {
							if (this.recordToEdit[item.key]) {
								if ($(`.${item.key + index}`).val() !== "") {
									let length = this.recordToEdit[item.key]
										.split(" ")[0]
										.split("-")[0]
										.split("").length;
									if (length == 3) {
										this.recordToEdit[item.key] =
											parseInt(
												this.recordToEdit[
													item.key
												].split("-")[0]
											) +
											1911 +
											this.recordToEdit[item.key].slice(
												3
											);
									} else {
										// 日期 西元轉民國 前面補0

										let date =
											parseInt(
												this.recordToEdit[item.key]
											) -
												1911 <
											100
												? `0${
														parseInt(
															this.recordToEdit[
																item.key
															]
														) - 1911
												  }${this.recordToEdit[item.key]

														.split(" ")[0]
														.slice(4)}`
												: `${
														parseInt(
															this.recordToEdit[
																item.key
															]
														) - 1911
												  }${this.recordToEdit[item.key]

														.split(" ")[0]
														.slice(4)}`;

										setTimeout(() => {
											$(`.${item.key + index}`).val(
												`${date}`
											);
										}, 200);
									}
								} else {
									let date =
										parseInt(this.recordToEdit[item.key]) -
											1911 <
										100
											? `0${
													parseInt(
														this.recordToEdit[
															item.key
														]
													) - 1911
											  }${this.recordToEdit[item.key]
													.split(" ")[0]
													.slice(4)}`
											: `${
													parseInt(
														this.recordToEdit[
															item.key
														]
													) - 1911
											  }${this.recordToEdit[item.key]
													.split(" ")[0]
													.slice(4)}`;
									setTimeout(() => {
										$(`.${item.key + index}`).val(
											`${date}`
										);
									}, 200);
								}
							} else {
								// 這裡是日期欄位第一次被建立的地方，要用 $set 建成反應性屬性，
								// 否則之後 el-form-item 的 fieldValue 會一直是舊值，驗證跟著失準
								if ($(`.${item.key + index}`).val() == "") {
									this.$set(this.recordToEdit, item.key, "");
								} else if ($(`.${item.key + index}`).val()) {
									let date =
										parseInt(
											$(`.${item.key + index}`)
												.val()
												.split("-")[0]
										) +
										1911 +
										$(`.${item.key + index}`)
											.val()
											.slice(3);
									this.$set(this.recordToEdit, item.key, date);
								}
							}
						}, 200);
					} else if (item.type == "datetime") {
						setTimeout(() => {
							if (this.recordToEdit[item.key]) {
								if ($(`.${item.key + index}`).val() !== "") {
									let length = this.recordToEdit[item.key]
										.split(" ")[0]
										.split("-")[0]
										.split("").length;
									if (length == 3) {
										this.recordToEdit[item.key] =
											parseInt(
												this.recordToEdit[
													item.key
												].split("-")[0]
											) +
											1911 +
											this.recordToEdit[item.key].slice(
												3
											);
									} else {
										// 日期 西元轉民國 前面補0
										let date =
											parseInt(
												this.recordToEdit[item.key]
											) -
												1911 <
											100
												? `0${
														parseInt(
															this.recordToEdit[
																item.key
															]
														) - 1911
												  }${this.recordToEdit[item.key]

														.split(" ")[0]
														.slice(4)}`
												: `${
														parseInt(
															this.recordToEdit[
																item.key
															]
														) - 1911
												  }${this.recordToEdit[item.key]

														.split(" ")[0]
														.slice(4)}`;

										setTimeout(() => {
											$(`.${item.key + index}`).val(
												`${date}`
											);
										}, 1);
									}
								} else {
									let date =
										parseInt(this.recordToEdit[item.key]) -
											1911 <
										100
											? `0${
													parseInt(
														this.recordToEdit[
															item.key
														]
													) - 1911
											  }${this.recordToEdit[item.key]
													.split(" ")[0]
													.slice(4)}`
											: `${
													parseInt(
														this.recordToEdit[
															item.key
														]
													) - 1911
											  }${this.recordToEdit[item.key]
													.split(" ")[0]
													.slice(4)}`;
									setTimeout(() => {
										$(`.${item.key + index}`).val(
											`${date}`
										);
									}, 1);
								}

								if (this.recordToEdit[item.key].split(" ")[1]) {
									this.$set(
										this.datetime,
										[item.key],
										this.recordToEdit[item.key].split(
											" "
										)[1]
									);
								}
							} else {
								if ($(`.${item.key + index}`).val() == "") {
									this.recordToEdit[item.key] = "";
								} else if ($(`.${item.key + index}`).val()) {
									let date =
										parseInt(
											$(`.${item.key + index}`)
												.val()
												.split("-")[0]
										) +
										1911 +
										$(`.${item.key + index}`)
											.val()
											.slice(3);

									this.recordToEdit[item.key] = date;
								}
							}
						}, 300);
					}
					// else if (item.type == "datetime") {
					//     if (this.recordToEdit[item.key]) {
					//         // 日期時間 西元轉民國
					//         let date =
					//             parseInt(
					//                 this.recordToEdit[item.key + index]
					//                     .split(" ")[0]
					//                     .split("-")[0]
					//             ) -
					//             1911 +
					//             this.recordToEdit[item.key + index]
					//                 .split(" ")[0]
					//                 .slice(4);
					//         setTimeout(() => {
					//             $(`.${item.key + index}`).val(`${date}`);
					//         }, 0);
					//         this.datetime[item.key] = this.recordToEdit[
					//             item.key + index
					//         ].split(" ")[1];
					//     } else {
					//         if ($(`.${item.key + index}`).val() !== "") {
					//             $(`.${item.key + index}`).val();
					//         } else {
					//             $(`.${item.key + index}`).val(``);
					//         }
					//     }
					// }
					else if (item.type == "timerange") {
						setTimeout(() => {
							this.timerange = [
								this.recordToEdit[item.key[0]],
								this.recordToEdit[item.key[1]],
							];
						}, 300);
					} else if (item.type == "address") {
						this.address[item.key] = [
							this.recordToEdit[item.key + "CityId"],
							this.recordToEdit[item.key + "AreaId"],
						];
						this.$nextTick(() => {
							if (this.recordToEdit[item.key + "Zipcode"] == "") {
								this.handleCountryChange(
									item,
									this.address[item.key]
								);
							}
						});
					} else if (item.type == "remoteselect") {
						this.formType.forEach((items, index) => {
							if (items.type == "remoteselect") {
								this.remoteindex[items.key] = index;
							}
						});
					} else if (item.type == "input" && item.addcomma) {
						if (this.recordToEdit[item.key]) {
							// this.recordToEdit[item.key] = this.recordToEdit[
							//     item.key
							// ]
							//     .toString()
							//     .replace(/,/g, "");
							setTimeout(() => {
								this.recordToEdit[item.key] = this.$addcomma(
									this.recordToEdit[item.key]
								);
							}, 1);
						} else {
							this.recordToEdit[item.key] = "0";
						}
					} else if (item.type == "columns") {
						if (typeof this.recordToEdit[item.key] == "object") {
							setTimeout(() => {
								// 取得 columns 欄位渲染選擇
								let arr = item.data.filter((item1) => {
									return this.recordToEdit[item.key].filter(
										(item2) => {
											return item1.name == item2;
										}
									)[0];
								});
								if (arr.length > 0) {
									arr.forEach((row) => {
										this.$refs.multipleTable[0].toggleRowSelection(
											row,
											true
										);
									});
								}
							}, 1);
						}
					}
				});
			},
		},
		address: {
			handler(item) {
				Object.keys(item).forEach((item, idx) => {
					this.countrys.filter((keys) => {
						if (this.address[item][0] == keys.id) {
							let allString = "";
							keys.children.filter((children) => {
								if (this.recordToEdit[item + "Street"] !== "") {
									setTimeout(() => {
										allString = `${keys.name}${
											children.name
										}${this.recordToEdit[item + "Street"]}`;
									}, 100);
									// this.$refs["recordToEdit"].resetFields();
								} else {
									allString = "";
									// this.$refs["recordToEdit"].clearValidate();
									// this.$refs["recordToEdit"].resetFields();
								}
							});
							this.recordToEdit[item] = allString;
						}
					});
				});
			},
		},
		currentEdit: {
			handler: function () {
				this.$emit("currentEditChange", this.currentEdit);
			},
			deep: true,
		},
	},
	created() {
		this.formType.forEach((item, index) => {
			if (item.type == "chooseMember") {
				// 預處理 chooseMember 的 member 為 array
				this.$set(this.chooseMember, [item.key], { showLabel: "" });
				this.$set(this.dialogMember, [item.key], false);
			} else if (item.type == "chooseMemberRange") {
				this.$set(this.chooseMember, [item.key[0]], { showLabel: "" });
				this.$set(this.chooseMember, [item.key[1]], { showLabel: "" });
				this.$set(this.dialogMember, [item.key], false);
			} else if (item.type == "chooseMemberMultiple") {
				this.$set(this.chooseMemberMultiple, [item.key], []);
				this.$set(this.chooseMemberMultipleTitle, [item.key], []);
				this.$set(this.dialogMultipleMember, [item.key], false);
			} else if (item.type == "listMultiple") {
				this.$set(this.currentEditMultiple, [item.key], []);
				this.$set(this.dialogListFormMultiple, [item.key], false);
			} else if (item.type == "email" || item.type == "sms") {
				// 預處理 email sms 通知對象 為 array
				this.$set(this.recordToEdit, [item.key], []);
			} else if (item.type == "editor") {
				// editor 預設為 string
				this.$set(this.recordToEdit, [item.key], "");
			} else if (item.type == "multicascader") {
				// 預處理 multicascader 為 array
				this.$set(this.recordToEdit, [item.key], []);
			} else if (item.type == "checkboxGroup") {
				// 預處理 checkboxGroup 是多項的時候為 array
				if (this.recordToEdit[item.key] === undefined) {
					this.$set(this.recordToEdit, [item.key], []);
				}
			} else if (item.type == "address") {
				// 地址 取得 country 及將分開的id 組合成 array
				this.getCountry();
				this.$set(this.address, [item.key], []);
				this.$set(this.recordToEdit, [item.key + "Zipcode"], "");
				setTimeout(() => {
					this.address[item.key] = [
						this.recordToEdit[item.key + "CityId"],
						this.recordToEdit[item.key + "AreaId"],
					];
					if (this.recordToEdit[item.key + "Zipcode"] == "") {
						this.handleCountryChange(item, this.address[item.key]);
					}
				}, 700);
			} else if (
				item.type == "birthcountry" &&
				this.countrys.length == 0
			) {
				// this.getjobID();
				this.$set(this.jobId, [item.key], []);
				setTimeout(() => {
					this.jobId[item.key] = [
						this.recordToEdit[item.key + "jobId"],
					];
					if (this.recordToEdit[item.key + "Zipcode"] == "") {
						this.handleCountryChange(item, this.address[item.key]);
					}
				}, 700);
			} else if (item.type == "datetime") {
				// 預處理 datetime 的 time 為 ""
				this.$set(this.datetime, [item.key], "");
				setTimeout(() => {
					if (this.recordToEdit[item.key]) {
						this.datetime[item.key] =
							this.recordToEdit[item.key].split(" ")[1];
					}
				}, 700);
			} else if (item.type == "timerange") {
				// timerange 組合成 array
				this.$set(this.recordToEdit, [item.key[0]], "");
				this.$set(this.recordToEdit, [item.key[1]], "");
				this.timerange = [
					this.recordToEdit[item.key[0]],
					this.recordToEdit[item.key[1]],
				];
			}
			// else if (item.type == "datetimerange" || item.type == "daterange") {
			//     // datetimerange daterange 組合成 array
			//     this.$set(this.recordToEdit, item.key, "");
			//     setTimeout(() => {
			//         if (this.recordToEdit[item.keyArray[0]]) {
			//             this.$set(this.recordToEdit, item.key, [
			//                 this.recordToEdit[item.keyArray[0]],
			//                 this.recordToEdit[item.keyArray[1]]
			//             ]);
			//         }
			//     }, 700);
			// }
			else if (item.type == "bussinesshours") {
				var arr = [];
				for (var i = 0; i <= 6; i++) {
					arr.push({
						day: i,
						openHour: "",
						openTime: "",
						closeHour: "",
						closeTime: "",
						notNeedWork: 0,
						timerange: "",
					});
				}
				this.$set(this.recordToEdit, item.key, arr);

				setTimeout(() => {
					for (var i = 0; i <= 6; i++) {
						var arr = [
							`${this.recordToEdit[item.key][i].openHour}:${
								this.recordToEdit[item.key][i].openTime
							}`,
							`${this.recordToEdit[item.key][i].closeHour}:${
								this.recordToEdit[item.key][i].closeTime
							}`,
						];
						this.$set(
							this.recordToEdit[item.key][i],
							"timerange",
							arr
						);
					}
				}, 700);
			} else if (item.type == "input" && item.addcomma) {
				if (this.recordToEdit[item.key] === undefined) {
					this.$set(this.recordToEdit, item.key, "");
				}
			}
		});
	},
	mounted() {
		const vm = this;
		vm.formType.forEach((item, index) => {
			if (item.type == "date" || item.type == "datetime") {
				const opts = {
					changeYear: true,
					changeMonth: true,
					currentText: "今天",
					dateFormat: "Rmmdd",
					showButtonPanel: true,
					yearRange: "1912:c+10",
					onSelect(data) {
						vm.getDate(data, item.key);
					},
				};
				if (item.maxDate === "today") opts.maxDate = "+0m +0w";
				const $input = $(`.${item.key + index}`);
				$input.datepicker(opts);
				// 理事會審查日期
				$(".councilAuditDate").datepicker(
					"option",
					"maxDate",
					"+0m +0w"
				);
				// 切到子頁面再切回來時本元件會重建，但 recordToEdit 參考沒變不會觸發 watch，
				// 這裡把既有值補寫回輸入框，否則日期欄位會顯示成空白
				if (vm.recordToEdit[item.key] && $input.val() === "") {
					$input.val(vm.$transferDate(vm.recordToEdit[item.key]));
				}
			}
		});
	},
	methods: {
		// getMember: debounce(function(query) {
		//     const queryObj = {
		//         search: query
		//     };
		//     const url = API.member + `?where=${JSON.stringify(queryObj)}`;
		//     const thenCB = json => {
		//         /*    this.memberOptions = json.resultData.enumData.member;
		//         this.loading = false; */
		//     };
		//     this.loading = true;
		//     this.mAxiosGet(url, thenCB);
		// }, 800),
		async getCountry() {
			if (this.countrysFlag) {
				// 避免重複呼叫 API 造成效能問題
				this.countrysFlag = false;

				const url = API.genCity + `?action=tree`;
				try {
					const json = await this.mAxiosGet(url);

					this.countrys = Object.assign(
						[],
						this.countrys,
						json.resultData.children
					);
				} catch (error) {
					this.countrysFlag = true; 
					console.error(error);
				}
			}
		},
		getEnum() {
			const vm = this;
			const url = API.member + `?id=${this.id}`;
			this.$http.get(url).then((response) => {
				vm.memberOptions = response.data.resultData.enumData.member;
				vm.jobId = response.data.resultData.enumData.genJob;
			});
		},
		getmemberId() {
			const url = API.member + `?id=${this.id}`;
			const thenCB = (json) => {
				this.jobId = Object.assign(
					[],
					this.jobId,
					json.resultData.enumData.member
				);
			};
			this.mAxiosGet(url, thenCB);
		},
		// 處理選取地址
		handleCountryChange(item, value) {
			this.formType.forEach((form, index) => {
				if (form.sandKey == item.key) {
					// 所變更的地址欄位 符合 sandKey 並且 checkbox 地址同上 勾選
					if (
						form.type == "checkboxSandToTop" &&
						this.recordToEdit[form.key] &&
						this.recordToEdit[form.key] == 1 &&
						form.isAddress
					) {
						this.handleAddress(form);
					}
				}
			});
			this.recordToEdit[item.key + "CityId"] = value[0];
			this.recordToEdit[item.key + "AreaId"] = value[1];
			this.countrys.forEach((item1) => {
				if (item1.children) {
					item1.children.forEach((item2) => {
						if (value[1] == item2.id) {
							this.Zipcode[item.key] = item2.zipcode;
							this.recordToEdit[item.key + "Zipcode"] =
								item2.zipcode;
							this.$forceUpdate();
						}
					});
				}
			});
		},
		handleAddressChange(item) {
			this.formType.forEach((form, index) => {
				if (form.sandKey == item.key) {
					// 所變更的地址欄位 符合 sandKey 並且 checkbox 地址同上 勾選
					if (
						form.type == "checkboxSandToTop" &&
						this.recordToEdit[form.key] &&
						this.recordToEdit[form.key] == 1 &&
						form.isAddress
					) {
						this.handleAddress(form);
					}
				}
			});
		},
		handleAddress(item) {
			setTimeout(() => {
				this.recordToEdit[item.sandKey + "AreaId"] && (this.recordToEdit[item.targetKey + "AreaId"] =
					this.recordToEdit[item.sandKey + "AreaId"]);
				this.recordToEdit[item.sandKey + "CityId"] && (this.recordToEdit[item.targetKey + "CityId"] =
					this.recordToEdit[item.sandKey + "CityId"]);
				this.recordToEdit[item.sandKey + "Zipcode"] && (this.recordToEdit[item.targetKey + "Zipcode"] =
					this.recordToEdit[item.sandKey + "Zipcode"]);
				this.recordToEdit[item.sandKey + "Street"] && (this.recordToEdit[item.targetKey + "Street"] =
					this.recordToEdit[item.sandKey + "Street"]);
				this.recordToEdit[item.sandKey] && (this.recordToEdit[item.targetKey] =
					this.recordToEdit[item.sandKey]);

				this.address[item.targetKey] = [
					this.recordToEdit[item.sandKey + "CityId"],
					this.recordToEdit[item.sandKey + "AreaId"],
				];
 				this.Zipcode[item.sandKey] && (this.Zipcode[item.targetKey] = this.Zipcode[item.sandKey]);
			}, 400);
		},
		handleSandCountry(item, value) {
			this.recordToEdit[item.targetKey + "CityId"] = value[0];
			this.recordToEdit[item.targetKey + "AreaId"] = value[1];
		},
		handleTimerangeChange(item, value) {
			this.recordToEdit[item.key[0]] = value[0];
			this.recordToEdit[item.key[1]] = value[1];
		},
		handleBussinessHoursChange(item, value) {
			if (value != null) {
				item.openHour = value[0].split(":")[0];
				item.openTime = value[0].split(":")[1];
				item.closeHour = value[1].split(":")[0];
				item.closeTime = value[1].split(":")[1];
			} else {
				item.openHour = "";
				item.openTime = "";
				item.closeHour = "";
				item.closeTime = "";
			}
		},
		// quill editor
		onEditorBlur(quill, index) {
			// console.log('editor blur!', quill)
		},
		onEditorFocus(quill, index) {
			this.cursorPosition[index] =
				this.$refs[`myQuillEditor${index}`][0].quill.getSelection();
		},
		onEditorReady(quill, index) {
			// console.log('editor ready!', quill)
		},
		onEditorChange(value, index) {
			if (this.$refs[`myQuillEditor${index}`][0].quill.getSelection()) {
				this.cursorPosition[index] =
					this.$refs[`myQuillEditor${index}`][0].quill.getSelection();
			}
		},
		insertEditor(item, index) {
			if (this.insertColumn) {
				const insertIndex = this.cursorPosition[index].index;
				const columnLength = this.insertColumn.length;
				this.$refs[`myQuillEditor${index}`][0].quill.insertText(
					insertIndex,
					this.insertColumn
				);
				this.$refs[`myQuillEditor${index}`][0].quill.setSelection(
					insertIndex + columnLength
				);
			}
		},
		handleSelectionChange(item, val) {
			// 欄位照順序選擇
			if (val.length > 0) {
				var arr = [];
				item.data.forEach((item) => {
					val.forEach((item2) => {
						if (item2.name == item.name) {
							arr.push(item.name);
						}
					});
				});
				this.recordToEdit[item.key] = arr;
			}
		},
		handleClick(item, scop, go) {
			var arr = [];
			// 欄位設定的排序
			if (go == "up") {
				// 上移
				this.swapItem(item.data, scop.$index, scop.$index - 1);
			} else if (go == "down") {
				// 下移
				this.swapItem(item.data, scop.$index, scop.$index + 1);
			}
			// 移動已選擇的欄位
			if (this.recordToEdit[item.key]) {
				item.data.forEach((item2) => {
					this.recordToEdit[item.key].forEach((item3) => {
						if (item3 == item2.name) {
							arr.push(item2.name);
						}
					});
				});
			}
			this.recordToEdit[item.key] = arr;
		},
		swapItem(arr, fromIndex, toIndex) {
			// array 交換順序
			arr[toIndex] = arr.splice(fromIndex, 1, arr[toIndex])[0];
			return arr;
		},
		handleChange(value) {
			// console.log(value);
		},
		handleCheckboxSandToTopChange(index, value){
			// 點選通訊地址同戶籍地址 上一個欄位disable
			this.formType[index-1].disabled = Boolean(value);
			// 將戶籍地址同步道通訊地址
			this.handleAddress(this.formType[index])
		},
		// 多層select
		handleCascaderChange(value, item, target) {
			// 取得要寫入的欄位名稱
			const key = item.key || item.prop;

			// 使用 $set 確保響應式更新
			if (item.returnArray) {
				// 陣列回傳值
				this.$set(this[target], key, value[value.length - 2]);
				this.$set(this[target], item.subKey, value[value.length - 1]);

				// 寬度自動
				// var el_cascader_element = document.querySelector(
				//     ".el-cascader"
				// );
				// var length = value.join(".").length + 1;
				// var num = length * 10 + "px";
				// el_cascader_element.style.width = num;
			} else {
				// 單一回傳值
				this.$set(this[target], key, value[value.length - 1]);
			}

			// 手動觸發驗證 (讓紅字消失)
			this.$nextTick(() => {
				if (this.$refs[target]) {
					this.$refs[target].validateField(key);
				}
			});
		},
		// upload
		handleRemove(file, fileList, index) {
			this.$parent.formType[index].fileList = fileList;
			// 刪除
		},
		handlePreview(file) {
			// 預覽或下載
			if (file.url) {
				const url =
					API[this.api] + `?id=${this.id}&action=downloadForm`;
				this.mDownloadFile(url);
			}
		},
		beforeUpload(file) {
			// 上傳前檢查檔案
			const isPDF = file.type.includes("pdf");
			// const isLt2M = file.size / 1024 / 1024 < 2;

			if (!isPDF) {
				this.$message.error("上傳檔案只能是 PDF 格式!");
			}
			// if (!isLt2M) {
			// 	this.$message.error("上傳大小不能超過 2MB!");
			// }
			return isPDF;
		},
		beforeRemove(file, fileList) {
			// 移除前確認
			if (file && file.status === "success") {
				return this.$confirm(`確定移除 ${file.name}?`);
			}
		},
		upload(fileObj, index) {
			let obj = {
				name: fileObj.file.name,
			};
			this.$parent.formType[index].fileList.push(obj);
			this.fileObj = fileObj;
		},
		addList(index) {
			// list add
			this.dialogListForm = true;
			this.currentEdit = {};
			this.currentIndex = "new";
			this.formType[index].columns.forEach((item) => {
				if (item.type == "chooseMember") {
					// 預處理 chooseMember 的 member 為 array
					this.$set(this.chooseMember, [item.prop], {
						showLabel: "",
					});
					this.$set(this.dialogMember, [item.prop], false);
				} else if (item.type == "cascader") {
					// 清空data
					item.data = [];
				}
			});
		},
		addListMul(index) {
			// listMul add
			this.dialogListFormMultiple[key] = true;
			this.currentEdit[key] = [];
			this.currentIndex[key] = "new";
		},
		editList(row, index, formIndex) {
			// list edit
			this.dialogListForm = true;
			this.currentEdit = row;
			this.currentIndex = index;
			this.formType[formIndex].columns.forEach((item) => {
				if (item.type == "chooseMember") {
					// 預處理 chooseMember 的 member 為 array
					this.$set(this.chooseMember, [item.prop], {
						showLabel: "",
					});
					this.$set(this.dialogMember, [item.prop], false);

					this.getMemberById(this.currentEdit[item.prop], item);
				} else if (item.type == "cascader") {
					// 清空data
					item.data = this.currentEdit.genStakeholderTypePath;
				}
			});
		},
		editListMutiple(row, index, key) {
			// listMultiple edit
			this.dialogListFormMultiple[key] = true;
			this.currentEditMultiple[key] = row;
			this.currentIndex = index;
		},
		removeList(index, listIndex) {
			// list remove
			this.formType[index].data.splice(listIndex, 1);
		},
		//listMultiple remove
		removeListMul(index, listIndex, key) {
			this.formType[index].data.splice(listIndex, 1);
		},
		openMember(key, idx) {
			this.dialogMember[key] = true;
			this.chooseMemberIndex = idx;
			// this.$refs.member.getData();
		},
		openMultipleMember(key) {
			this.dialogMultipleMember[key] = true;
		},
		memberGetData() {
			// console.log(this.$refs);
		},
		removeItem(key) {
			//移除社員多選時 做的過濾
			var newArr = [];
			this.chooseMemberMultipleTitle[key].map((val) => {
				this.chooseMemberMultiple[key].map((item) => {
					if (val == `${item.account} ${item.name}`) {
						newArr.push(item);

						// console.log(
						//     this.chooseMemberMultipleTitle[key],
						//     this.chooseMemberMultiple[key]
						// );
					}
					// console.log(val, `${item.account} ${item.name}`);
				});
			});
			this.recordToEdit[key] = newArr;
			this.chooseMemberMultiple[key] = newArr;
			if (!this.chooseMemberMultipleTitle[key][0]) {
				//判斷是否已經沒有資料 如是清空陣列
				this.recordToEdit[key] = [];
				this.chooseMemberMultiple[key] = [];
			}
		},
		clickMember(id, row, item, key, editTarget) {
			if (item.type == "chooseMember") {
				if (item.returnKey) {
					this[editTarget][item[key]] = row[item.returnKey];
				} else {
					this[editTarget][item[key]] = row;
				}
				this.chooseMember[item[key]] = row;
				this.chooseMember[item[key]].showLabel = `${
					row.account || row.memberAccount || ""
				} ${row.name}`;
			} else if (item.type == "chooseMemberRange") {
				if (item.returnKey) {
					this[editTarget][item[key][this.chooseMemberIndex]] =
						row[item.returnKey];
				} else {
					this[editTarget][item[key][this.chooseMemberIndex]] = row;
				}
				this.chooseMember[item[key][this.chooseMemberIndex]] = row;
				this.chooseMember[
					item[key][this.chooseMemberIndex]
				].showLabel = `${row.account || row.memberAccount || ""} ${
					row.name
				}`;
			}

			this.$emit("itemChange", id, row, item);
			this.dialogMember[item.key || item.prop] = false;
		},
		clickMultiple(id, row, item, key) {
			//選擇社員多選時，增加資料
			let obj = {
				name: row.name, //目前傳出去的資料只傳名字 ID 跟 帳戶
				id: row.id,
				account: row.account,
			};
			this.chooseMemberMultiple[key].push(obj);
			this.chooseMemberMultipleTitle[key].push(
				`${row.account} ${row.name}`
			);
			this.recordToEdit[item.key] = this.chooseMemberMultiple[key];
			// this.$emit("mutipleChange", row);
			this.dialogMultipleMember[item.key] = false;
		},
		async getMemberById(key, item, targetKey = "") {
			let url;
			if (item.api) {
				// 判斷回傳是否為object 如果是回傳object 要再帶一層參數進去撈取ID，如果是object直接去撈會有錯誤
				// 判斷是否有 returnKey 有舊照那個 key 去get 否則用id get
				url = API[item.api] +
					`?${item.returnKey ? item.returnKey : "id"}=${
						typeof key == "object" ? key.id : key
					}`;
			} else {
				// 判斷回傳是否為object 如果是回傳object 要再帶一層參數進去撈取ID，如果是object直接去撈會有錯誤
				url = API.member + `?id=${typeof key == "object" ? key.id : key}&action=ActionGetMemberSimple`; 
			}
			try {
				const json = await this.mAxiosGet(url);

				this.chooseMember[item.key || item.prop] = json.resultData.data;
				this.chooseMember[item.key || item.prop].showLabel = `${
					json.resultData.data.account ||
					json.resultData.data.memberAccount ||
					""
				} ${json.resultData.data.name}`;
				this.$emit("getMemberData", json.resultData.data, targetKey);
			} catch (error) {
				// Error is handled by the mixin.
			}
		},
		saveDialogEdit(index) {
			let isAdd = this.checkEditValue(index);
			if (isAdd) {
				if (this.currentIndex == "new") {
					this.formType[index].data.push(this.currentEdit);
				} else {
					this.formType[index].data[this.currentIndex] =
						this.currentEdit;
				}
				this.dialogListForm = false;
			}
		},
		checkEditValue(index) {
			let result = true;
			this.formType[index].columns.forEach((column) => {
				if (
					column.isCheckValue == true &&
					column.checkFunc !== undefined
				) {
					result =
						result &&
						column.checkFunc(this.currentEdit[column.prop]);
				}
			});

			return result;
		},
		saveDialogEditMul(index, key, test) {
			if (this.currentIndex[key] == "new") {
				this.formType[index].data.push(this.currentEditMultiple[key]);
			} else {
				this.formType[index].data[this.currentEditMultiple] =
					this.currentEditMultiple[key];
			}
			this.dialogListFormMultiple[key] = false;
		},
		async submitForm(formName) {
			const isValid = await new Promise(resolve => {
				this.$refs[formName].validate(valid => resolve(valid));
			});

			if (!isValid) {
				const message = "請檢查並填寫必填欄位";
				this.$message.error(message);
				throw new Error(message);
			}

			try {
				this.otherValidate();
				const result = await this.saveData();
				return result;
			} catch (error) {
				// 顯示自訂驗證的錯誤，API 錯誤由 mAxiosPost mixin 處理
				if (error && error.message && !error.response) {
					this.$message.error(error.message);
				}
				// 向上拋出錯誤，讓呼叫者可以捕獲
				throw error;
			}
		},
		otherValidate() {
			// 部分驗證需額外處理 ex: chooseMember date cascader
			let validateFunc = (item) => {
				return (
					this.recordToEdit[item.key] == "" ||
					this.recordToEdit[item.key] == undefined
				);
			};
			this.formType.forEach((item) => {
				let tmpValidateFunc =
					item.validateEmptyFunc == undefined
						? validateFunc
						: item.validateEmptyFunc;
				if (
					tmpValidateFunc(item) &&
					item.require &&
					item.vif != false
				) {
					throw new Error(`請輸入${item.label}`);
				}
			});
		},
		async saveData() {
			const form = new FormData();
			const url = this.buildSaveUrl(form);

			this.formType.forEach((item, index) => {
				this.appendFormItem(form, item, index);
			});

			const json = await this.mAxiosPost(url, form);
			this.showAjaxSuccessMsg();
			this.pushRouter(json);
			this.$emit("formCB", json);
			return json;
		},
		/**
		 * 組出儲存用的 API 網址，編輯既有資料時順便把 id 帶進 form
		 * @param {FormData} form 要送出的表單
		 * @returns {string} 帶 action 的 API 網址
		 */
		buildSaveUrl(form) {
			const isExisting = this.id != "new" && this.id != 0;
			if (isExisting && this.id) {
				form.append("id", this.id);
			}

			const action = this.action || (isExisting ? "update" : "append");
			return `${API[this.api]}?action=${action}`;
		},
		/**
		 * 取 recordToEdit 的值寫入 form，值為 undefined 時改送 fallback
		 * @param {FormData} form 要送出的表單
		 * @param {string} key 欄位名，同時是 recordToEdit 與 form 的 key
		 * @param {*} fallback 值為 undefined 時要送出的預設值
		 */
		appendValue(form, key, fallback = "") {
			const value = this.recordToEdit[key];
			form.append(key, value !== undefined ? value : fallback);
		},
		/**
		 * 同 appendValue，但值會先 JSON 序列化
		 * @param {FormData} form 要送出的表單
		 * @param {string} key 欄位名，同時是 recordToEdit 與 form 的 key
		 * @param {*} fallback 值為 undefined 時要送出的預設值
		 */
		appendJson(form, key, fallback = "[]") {
			const value = this.recordToEdit[key];
			form.append(key, value !== undefined ? JSON.stringify(value) : fallback);
		},
		/**
		 * 依欄位型別把單一 formType 欄位寫入 form
		 * post 為 false 的欄位一律不送
		 * case 內 return 代表已處理完畢；break 代表交給 switch 後的共用預設送法
		 * （不能改成 default: —— break 跳出 switch 後不會進 default）
		 * @param {FormData} form 要送出的表單
		 * @param {object} item formType 的欄位定義
		 * @param {number} index 欄位在 formType 的索引，datetime 用它定位 DOM
		 */
		appendFormItem(form, item, index) {
			// 若 post 為 false 則不加入表單資料
			if (item.post === false) {
				return;
			}
			
			switch (item.type) {
				case "checkbox":
					// checkbox 只有一個 無資料傳 0
					if (item.options.length == 1) {
						this.appendValue(form, item.key, 0);
						return;
					}
					// checkbox 多個 無資料傳 []
					if (item.options.length > 1) {
						this.appendJson(form, item.key);
						return;
					}
					break;
				case "checkboxGroup":
				case "multiselect":
					// checkboxGroup multiselect 多個 無資料傳 []
					this.appendJson(form, item.key);
					return;
				case "input":
					// 金額欄位送出前去掉千分位
					if (item.addcomma || item.replaceComma) {
						// 空值或字串 "undefined" 不送，避免 toString 炸掉
						if (
							this.recordToEdit[item.key] != null &&
							this.recordToEdit[item.key] !== "undefined"
						) {
							form.append(
								item.key,
								this.recordToEdit[item.key]
									.toString()
									.replace(/,/g, "")
							);
						}
						return;
					}
					break;
				case "chooseMemberMultiple":
					form.append(
						item.key,
						JSON.stringify(this.recordToEdit[item.key])
					);
					return;
				case "multicascader": {
					// multicascader 多個 無資料傳 [] 須先過濾 null
					const values = this.recordToEdit[item.key] || [];
					form.append(
						item.key,
						JSON.stringify(values.filter((value) => value))
					);
					return;
				}
				case "cascader":
					// cascader 分 array 或 傳單一個
					if (item.returnArray) {
						this.appendValue(form, item.subKey);
					}
					this.appendValue(form, item.key);
					return;
				case "email":
				case "sms":
					// sms email 無資料傳 [] 多傳設定欄位 無資料傳 0
					this.appendJson(form, item.key);
					this.appendJson(form, item.setting, 0);
					return;
				case "address":
					// 地址 欄位都相對寫死
					this.appendValue(form, item.key + "CityId", 0);
					this.appendValue(form, item.key + "AreaId", 0);
					this.appendValue(form, item.key + "Street");
					this.appendValue(form, item.key + "Zipcode");
					return;
				case "date":
					// 民國 日期
					if (this.recordToEdit[item.key]) {
						// 取日期部分，避免時間影響
						form.append(
							item.key,
							this.recordToEdit[item.key].split(" ")[0]
						);
						return;
					}
					break;
				case "datetime": {
					// 民國 日期時間
					const mingoDate = $(`.${item.key + index}`).val();
					if (mingoDate) {
						const time = this.datetime[item.key];
						const date =
							parseInt(mingoDate.split("-")[0]) +
							1911 +
							mingoDate.slice(3);
						form.append(item.key, time ? `${date} ${time}` : "");
						return;
					}
					break;
				}
				case "timerange":
					// 時間範圍
					this.appendValue(form, item.key[0]);
					this.appendValue(form, item.key[1]);
					return;
				case "post":
					// 單純 post 的值
					form.append(item.key, item.value);
					return;
				case "list":
					if (item.key) {
						form.append(
							item.key,
							JSON.stringify(this.normalizeListData(item))
						);
						return;
					}
					break;
				case "listMultiple":
					if (item.api) {
						// listMultiple 自帶 api 時由外層另外送出，這裡不帶欄位
						return;
					}
					// listMultiple post 上一層的 data
					if (item.key) {
						form.append(
							item.key,
							item.data !== undefined
								? JSON.stringify(item.data)
								: []
						);
						return;
					}
					break;
				case "bussinesshours":
					this.appendJson(form, item.key);
					return;
				case "upload":
					this.appendUploadValue(form);
					return;
				case "editor":
					// 缺少編碼 待補
					form.append(
						item.key,
						this.recordToEdit[item.key] !== undefined
							? encodeURI(
									this.recordToEdit[item.key]
										// .replace(/\s/g, "&nbsp;")
										.replace(/<br>/g, "<br />")
							  )
							: ""
					);
					return;
				case "select": {
					// 最後一個選項帶 inputKey 時，連同它的輸入值一起送出
					const lastOption = item.options[item.options.length - 1];
					if (lastOption && lastOption.inputKey) {
						this.appendValue(form, item.key);
						this.appendValue(form, lastOption.inputKey);
						return;
					}
					break;
				}
				case "radio":
					this.appendValue(form, item.key);
					if (item.options && item.options.length > 0) {
						item.options.forEach((option) => {
							if (option.inputKey) {
								this.appendValue(form, option.inputKey);
							}
						});
					}
					return;
			}

			// 其餘型別 直接送 recordToEdit 對應的值
			if (item.key) {
				this.appendValue(form, item.key);
			}
		},
		/**
		 * 送出前正規化 list 的列資料，目前只處理 addcomma 欄位的千分位
		 * @param {object} item type 為 list 的 formType 欄位定義
		 * @returns {Array} 正規化後的列資料
		 */
		normalizeListData(item) {
			const typeHandlers = {
				// 處理 type: 'input' 的邏輯
				input: (value, col) => {
					// 只有當 addcomma 屬性為 true 時才移除逗號
					if (col.addcomma === true && value != null) {
						return this.$removeComma(value);
					}
					return value; // 其他情況原樣返回
				},
				// ...未來可以不斷在這裡添加新的 type 處理器
			};

			const rows = item.data !== undefined ? item.data : [];
			if (rows.length > 0) {
				// 取得所有定義在 handlers 中的欄位，避免無謂的遍歷
				const processableColumns = item.columns.filter(
					(col) => typeHandlers[col.type]
				);
				rows.forEach((row) => {
					processableColumns.forEach((col) => {
						row[col.prop] = typeHandlers[col.type](row[col.prop], col);
					});
				});
			}

			return rows;
		},
		/**
		 * 送出上傳欄位，有選新檔案就送檔案，否則沿用原本的路徑
		 * @param {FormData} form 要送出的表單
		 */
		appendUploadValue(form) {
			if (Object.keys(this.fileObj).length === 0) {
				this.appendValue(form, "filePath");
				return;
			}

			form.append(
				"filePathUpload",
				this.fileObj.file !== undefined ? this.fileObj.file : ""
			);
			form.append(
				"fileName",
				this.fileObj.file.name !== undefined ? this.fileObj.file.name : ""
			);
		},
		pushRouter(json) {
			// 1. 不是新增資料，則不需要重導向
			if (this.id !== "new" && this.id !== 0) {
				return;
			}

			const currentParams = this.$route.params;
			const resultData = json.resultData;
			const newParams = {};

			// 2. 依照優先級決定要更新的定位參數
			if (currentParams.subId !== undefined) {
				newParams.subId = resultData.id;
				this.$parent.id = resultData.id;
			} else if (currentParams.id !== undefined) {
				newParams.id = resultData.id;
				this.$parent.id = resultData.id; 
			} else if (currentParams.coopCode !== undefined) {
				newParams.coopCode = resultData.coopCode || resultData.coopId; 
			} else if (currentParams.code !== undefined) {
				newParams.code = resultData.code;
			} else {
				// 找不到任何符合的情境，不執行導航
				console.warn("pushRouter: No matching param key found to update.");
				return;
			}

			// 3. 執行重導向
			this.$router.push({
				name: this.$route.name,  // 保持相同的 route name
				params: newParams,       // 使用新的定位參數
				query: this.$route.query // 保留當前的 query string
			});
		},
		removeLabel(item) {
			//切換畫面時如沒切換router時可使用this.$refs 把當下選擇的社員陣列label帶進來後，移除當下選擇的社員
			// this.chooseMember[item[0]].showLabel = "";
			// this.chooseMember[item[1]].showLabel = "";
			this.chooseMember[item[0]] = {};
			this.chooseMember[item[1]] = {};
		},
		addressHandler() {
			//處理地址驗證沒有辦法通過的問題
			Object.keys(this.address).forEach((item, idx) => {
				this.countrys.filter((keys) => {
					if (this.address[item][0] == keys.id) {
						let allString = "";
						keys.children.filter((children) => {
							if (this.address[item][1] == children.id) {
								if (this.recordToEdit[item + "Street"] !== "") {
									allString = `${keys.name}${children.name}${
										this.recordToEdit[item + "Street"]
									}`;
								} else {
									allString = "";
								}
							}
						});
						this.recordToEdit[item] = allString;
					}
				});
			});
		},
		back() {
			if (this.changeBack) {
				this.$emit("back");
			} else {
				// 去掉最後一個 _後的詞 回到上一層
				let remove = this.$route.name.split("_");
				let name = this.$route.name.replace(
					`_${remove[remove.length - 1]}`,
					""
				);
				this.$router.push({ name: name });
			}
		},
		resetInput(amount, key) {
			return (this.recordToEdit[key] = this.$addcomma(
				this.$removeComma(amount)
			));
		},
		resetEditAmount(amount, key) {
			return (this.currentEdit[key] = this.$addcomma(
				this.$removeComma(amount)
			));
		},
		//select 遠端搜尋
		remoteQuery(query, index) {
			if (query !== "") {
				this.loading = true;
				setTimeout(() => {
					this.loading = false;
					this.formType[index].options = this.formType[
						index
					].states.filter((item) => {
						return item.label.indexOf(query) > -1;
					});
				}, 200);
			} else {
				this.formType[index].options = [];
			}
		},
		clear(item, key) {
			this.recordToEdit[key] = "";
			this.chooseMember[key] = "";
		},
		/**
		 * 選取民國日期後寫回西元日期
		 * @param {string} data datepicker 回傳的民國日期
		 * @param {string} key 對應的欄位
		 */
		getDate(data, key) {
			this.$forceUpdate();
			this.$set(
				this.recordToEdit,
				key,
				parseInt(data.split("-")[0]) + 1911 + "-" + data.slice(4)
			);

			// 手動觸發驗證 (讓紅字消失)
			this.$nextTick(() => {
				if (this.$refs.recordToEdit) {
					this.$refs.recordToEdit.validateField(key);
				}
			});
		},
		/**
		 * 清除日期欄位，儲存時後端會把該日期欄位寫回 NULL(後端需要加入對應更新SQL)
		 * @param param0 
		 * @param index 
		 */
		clearDate({ key }, index) {
			// 1. 同步清空實體 DOM 與 jQuery 套件記憶
			const $el = $(`.${key + index}`).val("");
			if ($el.hasClass("hasDatepicker")) $el.datepicker("setDate", null);

			// 2. 清空 Vue 狀態並強制畫面重繪
			this.$set(this.recordToEdit, key, "");
			this.$forceUpdate();
		},
		handleSelectDropdownToggle(visible) {
			if (visible) {
				this.$nextTick(() => {
					// 1. 解除 Element UI 隱藏原生 scrollbar 的 class
					const wraps = document.querySelectorAll('.el-scrollbar__wrap');
					wraps.forEach((wrap) => {
						wrap.classList.remove('el-scrollbar__wrap--hidden-default');
					});

					// 2. 移除 Element UI 自訂 scrollbar bar DOM 元件
					const bars = document.querySelectorAll('.el-scrollbar__bar');
					bars.forEach((bar) => {
						bar.remove();
					});
				});
			}
		}
	},
};
</script>
<style lang="scss" scoped>
.custom-mingo-date {
	// 限制寬度，確保跟其他 Element UI 元件的長度一致
	max-width: 220px;

	.clear-icon-hover {
		cursor: pointer;
		color: #c0c4cc; // Element UI 預設淺灰色
		transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

		&:hover {
			color: #909399; // Hover 時變深，給予點擊回饋
		}
	}
}

.title-border {
	border-bottom: 1px solid #e9e9e9;
	border-top: 1px solid #e9e9e9;
	padding: 15px 0;
	line-height: 1.5;
}

.el-form-item__content {
	.el-input {
		// max-width: 220px;
	}
}

// 輸入框下方灰色小字說明（hint / hintKey）
.form-item-hint {
	margin-top: 4px;
	font-size: 12px;
	line-height: 1.4;
	color: #909399;
	word-break: break-all;
}

.bussinesshours {
	.hour {
		width: 290px;
		border: 1px solid #ccc;
		padding: 10px;
		display: inline-block;
		margin-right: 10px;
		margin-bottom: 10px;

		.el-date-editor--timerange.el-input__inner {
			width: 100%;
		}
	}
}

.subTitle {
	position: relative;
	color: red;
	font-weight: 500;
	top: -5px;
}

.block-header {
	.subtime {
		font-weight: bold;
		float: right;
	}
}

.w200 {
	max-width: 200px;
}

.w250 {
	max-width: 250px;
}

.workbench ::v-deep {
	.search-input {
		width: 200px;
		margin: 0 0px 10px;
	}
}

// .el-select-dropdown ::v-deep {
//     .el-popper {
//         .menuHide {
//             display: none !important;
//         }
//     }
// }
</style>